export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends Record<string, unknown>> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends Record<string, unknown>, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> =
    | T
    | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    Date: { input: string; output: Date };
    DateTime: { input: string; output: Date };
    Email: { input: string; output: string };
    JSON: { input: Record<string, unknown>; output: Record<string, unknown> };
    NonEmptyString: { input: string; output: string };
    NonNegativeInt: { input: number; output: number };
    PhoneE164: { input: string; output: string };
    PositiveInt: { input: number; output: number };
    Time: { input: string; output: string };
    Timezone: { input: string; output: string };
    UUID: { input: string; output: string };
    ZipCode: { input: string; output: string };
};

export type AddZipCodesToTerritoryInput = {
    territoryId: Scalars['UUID']['input'];
    zipCodesToAdd: Scalars['ZipCode']['input'][];
};

export type Address = {
    __typename?: 'Address';
    address1: Scalars['String']['output'];
    address2: Scalars['String']['output'];
    city: Scalars['String']['output'];
    coordinates: Maybe<Coordinates>;
    id: Scalars['UUID']['output'];
    line1: Scalars['String']['output'];
    line2: Scalars['String']['output'];
    serviceAreas: ServiceArea[];
    state: Scalars['String']['output'];
    timezone: Scalars['Timezone']['output'];
    zipCode: Scalars['String']['output'];
    zipcode: Scalars['String']['output'];
};

export type AddressServiceAreasArgs = {
    serviceIds?: InputMaybe<Scalars['UUID']['input'][]>;
};

/** Expression of either an existing address, new address, or an indication that an address should be inferred from its context. */
export type AddressExpressionInput = {
    /** If provided, the specified existing address will be used. */
    addressId?: InputMaybe<Scalars['UUID']['input']>;
    /** If provided, a new address will be created and used. */
    addressInput?: InputMaybe<AddressInput>;
    /** If true, an address will be inferred from the context (e.g., patient or order information). If it is not possible to infer an address, an error will be thrown. */
    inferAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddressFilter = {
    AND?: InputMaybe<AddressFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<AddressFilter>;
    OR?: InputMaybe<AddressFilter>;
    city?: InputMaybe<StrBaseFilterLookup>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    state?: InputMaybe<StrBaseFilterLookup>;
    timezone?: InputMaybe<StrBaseFilterLookup>;
    zipCode?: InputMaybe<StrBaseFilterLookup>;
};

export type AddressInput = {
    city: Scalars['NonEmptyString']['input'];
    line1: Scalars['NonEmptyString']['input'];
    line2: Scalars['String']['input'];
    state: Scalars['NonEmptyString']['input'];
    zipCode: Scalars['ZipCode']['input'];
};

export enum AggregationOperator {
    AND = 'AND',
    OR = 'OR',
}

export type Appointment = {
    appointmentId: Scalars['UUID']['input'];
    serviceIds: Scalars['UUID']['input'][];
};

export type ApproveRequestToCreateShiftBlockInput = {
    id: Scalars['UUID']['input'];
};

export type ArchiveTerritoryInput = {
    territoryId: Scalars['UUID']['input'];
};

export type AssignedCliniciansAndPositionsInput = {
    clinicianId: Scalars['UUID']['input'];
    positionId: Scalars['UUID']['input'];
};

export type Availability = {
    __typename?: 'Availability';
    potentialAppointmentAssignments: PotentialAppointmentAssignment[];
    timeOptions: TimeWindow[];
    timezone: Scalars['String']['output'];
};

export type AvailabilityFilter = {
    endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    startDatetime: Scalars['DateTime']['input'];
};

export type BetaCreateConfirmedVisitInput = {
    address: AddressInput;
    patientId?: InputMaybe<Scalars['UUID']['input']>;
    patientUuid?: InputMaybe<Scalars['UUID']['input']>;
    serviceAreaId?: InputMaybe<Scalars['UUID']['input']>;
    serviceAreaUuid?: InputMaybe<Scalars['UUID']['input']>;
    serviceAssignments?: InputMaybe<ServiceAssignment[]>;
    serviceBundleAssignments?: InputMaybe<ServiceBundlePositionAssignment[]>;
    serviceBundleId?: InputMaybe<Scalars['UUID']['input']>;
    serviceBundleUuid?: InputMaybe<Scalars['UUID']['input']>;
    serviceIds?: InputMaybe<Scalars['UUID']['input'][]>;
    startDatetime: Scalars['DateTime']['input'];
};

export type BetaCreateUnconfirmedVisitInput = {
    address: AddressInput;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    patientId?: InputMaybe<Scalars['UUID']['input']>;
    patientUuid?: InputMaybe<Scalars['UUID']['input']>;
    serviceAreaId?: InputMaybe<Scalars['UUID']['input']>;
    serviceAreaUuid?: InputMaybe<Scalars['UUID']['input']>;
    serviceAssignments?: InputMaybe<ServiceAssignment[]>;
    serviceBundleAssignments?: InputMaybe<ServiceBundlePositionAssignment[]>;
    serviceBundleId?: InputMaybe<Scalars['UUID']['input']>;
    serviceBundleUuid?: InputMaybe<Scalars['UUID']['input']>;
    serviceIds?: InputMaybe<Scalars['UUID']['input'][]>;
    timeslotPreferences: VisitTimeslotPreferenceInput[];
};

export type BetaEditClinicianAppointmentInput = {
    appointmentStartDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    clinicianAppointmentId: Scalars['UUID']['input'];
    shouldSendPatientComms?: InputMaybe<Scalars['Boolean']['input']>;
    state?: InputMaybe<ClinicianAppointmentState>;
    timeslotPreferences?: InputMaybe<VisitTimeslotPreferenceInput[]>;
};

export type BetaEditClinicianAppointmentSuccessResult = {
    __typename?: 'BetaEditClinicianAppointmentSuccessResult';
    clinicianAppointment: ClinicianAppointment;
    visit: Maybe<Visit>;
};

export type BetaEditVisitInput = {
    outcome?: InputMaybe<VisitOutcome>;
    startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    state?: InputMaybe<VisitState>;
    tentativeDate?: InputMaybe<Scalars['Date']['input']>;
    timeslotPreferences?: InputMaybe<VisitTimeslotPreferenceInput[]>;
    visitId: Scalars['UUID']['input'];
};

export type BetaFinalizeRoutesInput = {
    shouldSendPatientComms?: InputMaybe<Scalars['Boolean']['input']>;
    solutionTraceId?: InputMaybe<Scalars['UUID']['input']>;
    tentativeVisitsToFinalize: TentativeVisitScheduleAndAssignments[];
};

export type BookUnscheduledVisitInput = {
    assignedCliniciansAndPositions: AssignedCliniciansAndPositionsInput[];
    startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    visitId: Scalars['UUID']['input'];
};

export type BoolBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<Scalars['Boolean']['input']>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<Scalars['Boolean']['input'][]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkMutationError = {
    __typename?: 'BulkMutationError';
    message: Scalars['String']['output'];
};

export type BulkPromoteVisitRequestsInput = {
    visitRequests: PromoteVisitRequestInput[];
};

export type BulkUpdateVisitRequestAppointmentClinicianAssignmentInput = {
    visitRequests: UpdateVisitRequestAppointmentClinicianAssignmentInput[];
};

export type BulkUpdateVisitRequestAppointmentClinicianAssignmentResponse = {
    __typename?: 'BulkUpdateVisitRequestAppointmentClinicianAssignmentResponse';
    errorCount: Scalars['Int']['output'];
    results: VisitRequestBulkMutationResult[];
    success: Scalars['Boolean']['output'];
    successCount: Scalars['Int']['output'];
    totalCount: Scalars['Int']['output'];
};

export type BulkUpdateVisitRequestClinicianAppointmentServicesInput = {
    visitRequests: UpdateVisitRequestClinicianAppointmentServicesInput[];
};

export type BulkUpdateVisitRequestClinicianAppointmentServicesResponse = {
    __typename?: 'BulkUpdateVisitRequestClinicianAppointmentServicesResponse';
    errorCount: Scalars['Int']['output'];
    results: VisitRequestBulkMutationResult[];
    success: Scalars['Boolean']['output'];
    successCount: Scalars['Int']['output'];
    totalCount: Scalars['Int']['output'];
};

export type BulkUpdateVisitRequestTentativeDateInput = {
    visitRequests: UpdateVisitRequestTentativeDateInput[];
};

export type BulkUpdateVisitRequestTentativeDateResponse = {
    __typename?: 'BulkUpdateVisitRequestTentativeDateResponse';
    errorCount: Scalars['Int']['output'];
    results: VisitRequestBulkMutationResult[];
    success: Scalars['Boolean']['output'];
    successCount: Scalars['Int']['output'];
    totalCount: Scalars['Int']['output'];
};

export type BulkVisitRequestsDecisionSupport = {
    __typename?: 'BulkVisitRequestsDecisionSupport';
    clinicianRecommendations: Maybe<VisitRequestClinicianAppointmentClinicianRecommendations[]>;
    dateRecommendations: Maybe<VisitRequestDateRecommendations[]>;
};

export type BulkVisitRequestsDecisionSupportClinicianRecommendationsArgs = {
    clinicianFilters?: InputMaybe<ClinicianFilter>;
};

export type BulkVisitsDecisionSupport = {
    __typename?: 'BulkVisitsDecisionSupport';
    clinicianRecommendations: Maybe<VisitClinicianAppointmentClinicianRecommendations[]>;
    dateRecommendations: Maybe<VisitDateRecommendations[]>;
};

export type BulkVisitsDecisionSupportClinicianRecommendationsArgs = {
    clinicianFilters?: InputMaybe<ClinicianFilter>;
};

export type Call = {
    __typename?: 'Call';
    callSid: Scalars['String']['output'];
    durationSeconds: Maybe<Scalars['Int']['output']>;
    status: Maybe<CallStatus>;
};

export enum CallStatus {
    BUSY = 'BUSY',
    CANCELED = 'CANCELED',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    IN_PROGRESS = 'IN_PROGRESS',
    NO_ANSWER = 'NO_ANSWER',
    QUEUED = 'QUEUED',
    RINGING = 'RINGING',
}

export type CancelClinicianShiftOccurrenceInput = {
    occurrenceStartDatetime: Scalars['DateTime']['input'];
    scope: RecurrenceMutationScope;
    shiftRecurrenceId: Scalars['UUID']['input'];
};

export type CancelClinicianShiftRecurrenceInput = {
    id: Scalars['UUID']['input'];
    occurrenceStartDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    scope: RecurrenceMutationScope;
};

export type CancelRequestToCreateShiftBlockInput = {
    id: Scalars['UUID']['input'];
    occurrenceStartDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    scope: RecurrenceMutationScope;
};

export type CancelShiftOccurrenceResult = {
    __typename?: 'CancelShiftOccurrenceResult';
    createdShiftRecurrence: Maybe<ShiftRecurrence>;
    editedShiftRecurrence: Maybe<ShiftRecurrence>;
    impactedVisits: Visit[];
};

export type CancelShiftRecurrenceResult = {
    __typename?: 'CancelShiftRecurrenceResult';
    createdShiftRecurrence: Maybe<ShiftRecurrence>;
    editedShiftRecurrence: Maybe<ShiftRecurrence>;
    impactedVisits: Visit[];
};

export type CapacityForService = {
    __typename?: 'CapacityForService';
    compatibility: CliniciansCompatibilityResults;
    dates: CapacityForServiceForDate[];
    service: Service;
};

export type CapacityForServiceForDate = {
    __typename?: 'CapacityForServiceForDate';
    compatibleClinicians: CapacityForServicesOutputForServiceForDateForClinician[];
    date: Scalars['Date']['output'];
    /** @deprecated Use `would_be_overfull` instead. */
    isFull: Scalars['Boolean']['output'];
    wouldBeOverfull: Scalars['Boolean']['output'];
};

export type CapacityForServicesOutputForServiceForDateForClinician = {
    __typename?: 'CapacityForServicesOutputForServiceForDateForClinician';
    clinician: Clinician;
    /** @deprecated Use would_be_overfull instead. */
    isFull: Scalars['Boolean']['output'];
    numClinicianAppointments: Scalars['Int']['output'];
    wouldBeOverfull: Scalars['Boolean']['output'];
};

export type CareTeam = {
    __typename?: 'CareTeam';
    clinicians: Clinician[];
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['UUID']['output'];
    patients: Patient[];
    updatedAt: Scalars['DateTime']['output'];
};

export type CareTeamFilter = {
    AND?: InputMaybe<CareTeamFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<CareTeamFilter>;
    OR?: InputMaybe<CareTeamFilter>;
    clinicians?: InputMaybe<ClinicianFilter>;
    createdAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    patients?: InputMaybe<PatientFilter>;
    updatedAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
};

export type CareTeamOrdering = {
    createdAt?: InputMaybe<Ordering>;
    updatedAt?: InputMaybe<Ordering>;
};

export type CareTeamPaginatedList = {
    __typename?: 'CareTeamPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: CareTeam[];
    totalCount: Scalars['Int']['output'];
};

export type Clinician = {
    __typename?: 'Clinician';
    activeCareTeamPatients: Maybe<PatientPaginatedList>;
    address: Maybe<Address>;
    adminChangelogLink: Maybe<Scalars['String']['output']>;
    arriveByShiftEnd: Maybe<Scalars['Boolean']['output']>;
    careTeams: CareTeamPaginatedList;
    caseload: Maybe<PatientPaginatedList>;
    clinicianAppointments: Maybe<ClinicianAppointmentPaginatedList>;
    clinicianRoles: Maybe<UserRole[]>;
    clinicianTeams: Maybe<ClinicianTeam[]>;
    communications: ClinicianCommunications;
    compatibleServices: Maybe<ServicePaginatedList>;
    createdAt: Scalars['DateTime']['output'];
    departAtShiftStart: Maybe<Scalars['Boolean']['output']>;
    disciplines: Discipline[];
    email: Scalars['Email']['output'];
    externalId: Scalars['String']['output'];
    externalIds: ExternalId[];
    firstName: Scalars['String']['output'];
    fullName: Scalars['String']['output'];
    hourlyRate: Scalars['NonNegativeInt']['output'];
    id: Scalars['UUID']['output'];
    isActive: Scalars['Boolean']['output'];
    isPhoneNumberLandline: Scalars['Boolean']['output'];
    languages: Language[];
    lastName: Scalars['String']['output'];
    leadTime: Scalars['NonNegativeInt']['output'];
    licenses: Maybe<License[]>;
    logoUrl: Maybe<Scalars['String']['output']>;
    mileage: Scalars['Float']['output'];
    mobileTerritories: Territory[];
    numMobileTerritories: Scalars['Int']['output'];
    numVirtualTerritories: Scalars['Int']['output'];
    optimizedRoutes: Maybe<RouteOptimizerResult>;
    orders: Maybe<OrderPaginatedList>;
    organization: Organization;
    payers: Maybe<Payer[]>;
    perVisitRate: Scalars['NonNegativeInt']['output'];
    permissions: ClinicianPermissions;
    phoneNumber: Maybe<Scalars['PhoneE164']['output']>;
    qualifications: Qualification[];
    schedule: ClinicianSchedule;
    selfSchedulableVisits: Maybe<VisitPaginatedList>;
    sex: Sex;
    syncStatus: Maybe<SyncStatus>;
    timezone: Maybe<Scalars['Timezone']['output']>;
    travelPath: Maybe<TimestampedCoordinates[]>;
    tripTasks: Maybe<TripTaskPaginatedList>;
    updatedAt: Scalars['DateTime']['output'];
    user: User;
    virtualTerritories: Territory[];
    visitDurationModifier: Scalars['NonNegativeInt']['output'];
    visitRequests: Maybe<VisitRequestPaginatedList>;
    visits: Maybe<ClinicianVisitPaginatedList>;
    waitlist: Maybe<ClinicianVisitWaitlist>;
};

export type ClinicianActiveCareTeamPatientsArgs = {
    filters?: InputMaybe<PatientFilter>;
    ordering?: InputMaybe<PatientOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type ClinicianCareTeamsArgs = {
    filters?: InputMaybe<CareTeamFilter>;
    pagination?: InputMaybe<PaginationInput>;
};

export type ClinicianCaseloadArgs = {
    filters?: InputMaybe<PatientFilter>;
    ordering?: InputMaybe<PatientOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type ClinicianClinicianAppointmentsArgs = {
    filters?: InputMaybe<ClinicianAppointmentFilter>;
    ordering?: InputMaybe<ClinicianAppointmentOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type ClinicianCompatibleServicesArgs = {
    filters?: InputMaybe<ServiceFilter>;
    ordering?: InputMaybe<ServiceOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type ClinicianDisciplinesArgs = {
    ordering?: InputMaybe<DisciplineOrdering>;
};

export type ClinicianMileageArgs = {
    dateWindow?: InputMaybe<DateWindowInput>;
    endDate?: InputMaybe<Scalars['DateTime']['input']>;
    endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    startDate?: InputMaybe<Scalars['DateTime']['input']>;
    startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClinicianOptimizedRoutesArgs = {
    counterfactualTimeAssignments?: CounterfactualTimeAssignment[];
    endDatetime: Scalars['DateTime']['input'];
    startDatetime: Scalars['DateTime']['input'];
    useInhouseSolver?: Scalars['Boolean']['input'];
    visitIds: Scalars['UUID']['input'][];
};

export type ClinicianOrdersArgs = {
    filters?: InputMaybe<OrderFilter>;
    ordering?: InputMaybe<OrderOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type ClinicianScheduleArgs = {
    endDate?: InputMaybe<Scalars['Date']['input']>;
    endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    filters?: InputMaybe<ClinicianScheduleFilters>;
    startDate?: InputMaybe<Scalars['Date']['input']>;
    startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClinicianSelfSchedulableVisitsArgs = {
    filters?: InputMaybe<SelfSchedulableVisitsFilter>;
    ordering?: InputMaybe<VisitOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type ClinicianTravelPathArgs = {
    endDatetime: Scalars['DateTime']['input'];
    startDatetime: Scalars['DateTime']['input'];
};

export type ClinicianTripTasksArgs = {
    filters?: InputMaybe<TripTaskFilter>;
    ordering?: InputMaybe<TripTaskOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type ClinicianVisitRequestsArgs = {
    filters?: InputMaybe<VisitRequestFilter>;
    ordering?: InputMaybe<VisitRequestOrdering>;
};

export type ClinicianVisitsArgs = {
    filters?: InputMaybe<VisitFilter>;
    ordering?: InputMaybe<VisitOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type ClinicianAppointment = {
    __typename?: 'ClinicianAppointment';
    adminChangelogLink: Maybe<Scalars['String']['output']>;
    clinician: Maybe<Clinician>;
    createdAt: Scalars['DateTime']['output'];
    decisionSupport: VisitClinicianAppointmentDecisionSupport;
    durationMinutes: Scalars['Int']['output'];
    durationOverrideMinutes: Maybe<Scalars['Int']['output']>;
    encounters: Encounter[];
    endDatetime: Maybe<Scalars['DateTime']['output']>;
    externalIds: ExternalId[];
    id: Scalars['UUID']['output'];
    isClinic: Scalars['Boolean']['output'];
    isMobile: Scalars['Boolean']['output'];
    isVirtual: Scalars['Boolean']['output'];
    mileage: Maybe<Scalars['Float']['output']>;
    modality: ClinicianAppointmentModality;
    outcome: ClinicianAppointmentOutcome;
    outcomeNotes: Scalars['String']['output'];
    patient: Maybe<Patient>;
    services: Service[];
    startDatetime: Maybe<Scalars['DateTime']['output']>;
    startOffsetMinutes: Scalars['Int']['output'];
    state: ClinicianAppointmentState;
    syncStatus: Maybe<SyncStatus>;
    timezone: Scalars['Timezone']['output'];
    travelPath: Maybe<TimestampedCoordinates[]>;
    updatedAt: Scalars['DateTime']['output'];
    visit: Visit;
};

export type ClinicianAppointmentFilter = {
    AND?: InputMaybe<ClinicianAppointmentFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<ClinicianAppointmentFilter>;
    OR?: InputMaybe<ClinicianAppointmentFilter>;
    arePatientClinicianPayersCompatible?: InputMaybe<BoolBaseFilterLookup>;
    clinician?: InputMaybe<ClinicianFilter>;
    createdAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
    externalIds?: InputMaybe<ExternalIdFilter>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    organization?: InputMaybe<OrganizationFilter>;
    outcome?: InputMaybe<ClinicianAppointmentOutcomeBaseFilterLookup>;
    services?: InputMaybe<ServiceFilter>;
    state?: InputMaybe<ClinicianAppointmentStateBaseFilterLookup>;
    syncStatus?: InputMaybe<SyncStatusFilter>;
    updatedAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
    visit?: InputMaybe<VisitFilter>;
};

export type ClinicianAppointmentInput = {
    clinicianId?: InputMaybe<Scalars['UUID']['input']>;
    durationOverrideMinutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
    id?: InputMaybe<Scalars['UUID']['input']>;
    outcome?: ClinicianAppointmentOutcome;
    outcomeNotes?: InputMaybe<Scalars['String']['input']>;
    serviceIds: Scalars['UUID']['input'][];
    startOffsetMinutes: Scalars['NonNegativeInt']['input'];
    state?: ClinicianAppointmentState;
};

export enum ClinicianAppointmentModality {
    CLINIC = 'CLINIC',
    MOBILE = 'MOBILE',
    VIRTUAL = 'VIRTUAL',
}

export type ClinicianAppointmentOrdering = {
    clinician?: InputMaybe<ClinicianOrdering>;
    createdAt?: InputMaybe<Ordering>;
    organization?: InputMaybe<OrganizationOrdering>;
    startDatetime?: InputMaybe<Ordering>;
    updatedAt?: InputMaybe<Ordering>;
};

export enum ClinicianAppointmentOutcome {
    COMPLETED = 'COMPLETED',
    NONE = 'NONE',
    OTHER = 'OTHER',
    PATIENT_DID_NOT_SHOW = 'PATIENT_DID_NOT_SHOW',
}

export type ClinicianAppointmentOutcomeBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<ClinicianAppointmentOutcome>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<ClinicianAppointmentOutcome[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClinicianAppointmentPaginatedList = {
    __typename?: 'ClinicianAppointmentPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: ClinicianAppointment[];
    totalCount: Scalars['Int']['output'];
};

export type ClinicianAppointmentRequest = {
    clinicianId?: InputMaybe<Scalars['UUID']['input']>;
    id?: InputMaybe<Scalars['UUID']['input']>;
    serviceIds: Scalars['UUID']['input'][];
};

export enum ClinicianAppointmentState {
    AT_LOCATION = 'AT_LOCATION',
    ENDED = 'ENDED',
    EN_ROUTE = 'EN_ROUTE',
    NOT_STARTED = 'NOT_STARTED',
}

export type ClinicianAppointmentStateBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<ClinicianAppointmentState>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<ClinicianAppointmentState[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClinicianCommunications = {
    __typename?: 'ClinicianCommunications';
    clinicianSystemCommunications: Maybe<Communication[]>;
    id: Scalars['UUID']['output'];
};

export type ClinicianCommunicationsClinicianSystemCommunicationsArgs = {
    filters?: InputMaybe<CommunicationFilter>;
    ordering?: InputMaybe<CommunicationOrdering>;
};

export type ClinicianCompatibilityResult = {
    __typename?: 'ClinicianCompatibilityResult';
    clinician: Clinician;
    compatibilityResult: CompatibilityResult;
};

export type ClinicianEffectiveUnavailability = {
    __typename?: 'ClinicianEffectiveUnavailability';
    timeWindow: TimeWindow;
};

export type ClinicianEligibility = {
    __typename?: 'ClinicianEligibility';
    clinician: Clinician;
    eligibilityBoundResources: EligibilityBoundResourceForClinician[];
};

export type ClinicianFilter = {
    AND?: InputMaybe<ClinicianFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<ClinicianFilter>;
    OR?: InputMaybe<ClinicianFilter>;
    careTeams?: InputMaybe<CareTeamFilter>;
    clinicianTeams?: InputMaybe<ClinicianTeamFilter>;
    disciplines?: InputMaybe<DisciplineFilter>;
    externalId?: InputMaybe<StrBaseFilterLookup>;
    externalIds?: InputMaybe<ExternalIdFilter>;
    firstName?: InputMaybe<StrFilterLookup>;
    fullName?: InputMaybe<StrFilterLookup>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    isActive?: InputMaybe<BoolBaseFilterLookup>;
    lastName?: InputMaybe<StrFilterLookup>;
    mobileTerritories?: InputMaybe<TerritoryFilter>;
    numPayers?: InputMaybe<IntComparisonFilterLookup>;
    organization?: InputMaybe<OrganizationFilter>;
    overlappingTerritories?: InputMaybe<TerritoryFilter>;
    payers?: InputMaybe<PayerFilter>;
    qualifications?: InputMaybe<QualificationFilter>;
    searchTerm?: InputMaybe<Scalars['String']['input']>;
    shiftBlockRecurrences?: InputMaybe<ShiftBlockRecurrenceFilter>;
    shiftRecurrences?: InputMaybe<ShiftRecurrenceFilter>;
    virtualTerritories?: InputMaybe<TerritoryFilter>;
};

export type ClinicianOrdering = {
    createdAt?: InputMaybe<Ordering>;
    firstName?: InputMaybe<Ordering>;
    lastName?: InputMaybe<Ordering>;
    organization?: InputMaybe<OrganizationOrdering>;
    searchRanking?: InputMaybe<Ordering>;
    updatedAt?: InputMaybe<Ordering>;
};

export type ClinicianPaginatedList = {
    __typename?: 'ClinicianPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: Clinician[];
    totalCount: Scalars['Int']['output'];
};

export type ClinicianPermissions = {
    __typename?: 'ClinicianPermissions';
    callClinician: Scalars['Boolean']['output'];
    edit: Scalars['Boolean']['output'];
    id: Scalars['UUID']['output'];
    sendCommunications: Scalars['Boolean']['output'];
    viewCommunications: Scalars['Boolean']['output'];
};

export type ClinicianReservation = {
    __typename?: 'ClinicianReservation';
    clinician: Clinician;
    durationMinutes: Scalars['Int']['output'];
    endDatetime: Scalars['DateTime']['output'];
    id: Scalars['UUID']['output'];
    isVirtual: Scalars['Boolean']['output'];
    startDatetime: Scalars['DateTime']['output'];
    startOffsetMinutes: Scalars['Int']['output'];
    visitReservation: Reservation;
};

export type ClinicianSchedule = {
    __typename?: 'ClinicianSchedule';
    adjustedAvailabilityPercentage: Maybe<Scalars['Float']['output']>;
    clinicianAppointments: ClinicianAppointment[];
    clinicianReservations: ClinicianReservation[];
    effectiveUnavailability: ClinicianEffectiveUnavailability[];
    endDate: Maybe<Scalars['Date']['output']>;
    endDatetime: Scalars['DateTime']['output'];
    id: Scalars['UUID']['output'];
    shiftBlocks: ShiftBlockOccurrence[];
    shifts: ShiftOccurrence[];
    startDate: Maybe<Scalars['Date']['output']>;
    startDatetime: Scalars['DateTime']['output'];
    tentativeShiftBlocks: TentativeShiftBlockOccurrence[];
    tentativeShifts: TentativeShiftOccurrence[];
    timezone: Scalars['Timezone']['output'];
    tripTasks: TripTask[];
    unscheduledVisits: Visit[];
    visitRequests: VisitRequest[];
};

export type ClinicianScheduleTripTasksArgs = {
    ordering?: InputMaybe<TripTaskOrdering>;
};

export type ClinicianScheduleFilters = {
    shifts?: InputMaybe<ShiftRecurrenceFilter>;
    tentativeShiftBlocks?: InputMaybe<RequestToCreateShiftBlockFilter>;
    tentativeShifts?: InputMaybe<RequestToCreateShiftFilter>;
    tripTasks?: InputMaybe<TripTaskFilter>;
    visitRequests?: InputMaybe<VisitRequestFilter>;
    visits?: InputMaybe<VisitFilter>;
};

export type ClinicianSchedules = {
    __typename?: 'ClinicianSchedules';
    clinicianAppointments: ClinicianAppointment[];
    clinicianReservations: ClinicianReservation[];
    clinicians: Clinician[];
    endDate: Maybe<Scalars['Date']['output']>;
    endDatetime: Scalars['DateTime']['output'];
    shiftBlocks: ShiftBlockOccurrence[];
    shifts: ShiftOccurrence[];
    startDate: Maybe<Scalars['Date']['output']>;
    startDatetime: Scalars['DateTime']['output'];
    tentativeShiftBlocks: TentativeShiftBlockOccurrence[];
    tripTasks: TripTask[];
    unscheduledVisits: Visit[];
    visitRequests: VisitRequest[];
};

export type ClinicianSchedulesCliniciansArgs = {
    ordering?: InputMaybe<ClinicianOrdering>;
};

export type ClinicianSchedulesTripTasksArgs = {
    ordering?: InputMaybe<TripTaskOrdering>;
};

export type ClinicianSchedulesFilters = {
    clinicians?: InputMaybe<ClinicianFilter>;
    shifts?: InputMaybe<ShiftRecurrenceFilter>;
    tentativeShiftBlocks?: InputMaybe<RequestToCreateShiftBlockFilter>;
    tripTasks?: InputMaybe<TripTaskFilter>;
    visitRequests?: InputMaybe<VisitRequestFilter>;
    visits?: InputMaybe<VisitFilter>;
};

export type ClinicianSendSystemMessageToPatientInput = {
    customizedMessageBody?: InputMaybe<Scalars['String']['input']>;
    messageTypeKey: Scalars['String']['input'];
    visitId: Scalars['UUID']['input'];
};

export type ClinicianTeam = {
    __typename?: 'ClinicianTeam';
    adminChangelogLink: Maybe<Scalars['String']['output']>;
    clinicians: ClinicianPaginatedList;
    id: Scalars['UUID']['output'];
    name: Scalars['String']['output'];
    organization: Organization;
    timezones: Scalars['String']['output'][];
};

export type ClinicianTeamCliniciansArgs = {
    filters?: InputMaybe<ClinicianFilter>;
    ordering?: InputMaybe<ClinicianOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type ClinicianTeamFilter = {
    AND?: InputMaybe<ClinicianTeamFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<ClinicianTeamFilter>;
    OR?: InputMaybe<ClinicianTeamFilter>;
    clinicians?: InputMaybe<ClinicianFilter>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    name?: InputMaybe<StrFilterLookup>;
    organization?: InputMaybe<OrganizationFilter>;
};

export type ClinicianTeamOrdering = {
    name?: InputMaybe<Ordering>;
    organization?: InputMaybe<OrganizationOrdering>;
};

export type ClinicianTeamPaginatedList = {
    __typename?: 'ClinicianTeamPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: ClinicianTeam[];
    totalCount: Scalars['Int']['output'];
};

export type ClinicianVisitPaginatedList = {
    __typename?: 'ClinicianVisitPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: Visit[];
    performance: Maybe<ClinicianVisitPerformance>;
    totalCount: Scalars['Int']['output'];
};

export type ClinicianVisitPerformance = {
    __typename?: 'ClinicianVisitPerformance';
    averageRating: Maybe<Scalars['Float']['output']>;
    id: Scalars['UUID']['output'];
    numCompleted: Maybe<Scalars['Int']['output']>;
    numOnTime: Maybe<Scalars['Int']['output']>;
    numRequiringReschedule: Maybe<Scalars['Int']['output']>;
    numVisits: Scalars['Int']['output'];
    percentOnTime: Maybe<Scalars['Float']['output']>;
    percentRequiringReschedule: Maybe<Scalars['Float']['output']>;
};

export type ClinicianVisitWaitlist = {
    __typename?: 'ClinicianVisitWaitlist';
    claimableVisits: Maybe<VisitPaginatedList>;
    claimedVisits: Maybe<VisitPaginatedList>;
    id: Scalars['UUID']['output'];
};

export type ClinicianVisitWaitlistClaimableVisitsArgs = {
    filters?: InputMaybe<VisitFilter>;
    ordering?: InputMaybe<VisitOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type ClinicianVisitWaitlistClaimedVisitsArgs = {
    filters?: InputMaybe<VisitFilter>;
    ordering?: InputMaybe<VisitOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type CliniciansCompatibilityResults = {
    __typename?: 'CliniciansCompatibilityResults';
    allClinicians: ClinicianCompatibilityResult[];
    compatibleClinicians: ClinicianCompatibilityResult[];
    incompatibleClinicians: ClinicianCompatibilityResult[];
    numAllClinicians: Scalars['Int']['output'];
    numCompatibleClinicians: Scalars['Int']['output'];
    numIncompatibleClinicians: Scalars['Int']['output'];
};

export type Communication = {
    __typename?: 'Communication';
    call: Maybe<Call>;
    communicationType: CommunicationType;
    id: Scalars['UUID']['output'];
    message: Maybe<Message>;
    recipient: Maybe<Communicator>;
    recipientType: CommunicatorType;
    sender: Maybe<Communicator>;
    senderType: CommunicatorType;
    sentAt: Scalars['DateTime']['output'];
    visit: Maybe<Visit>;
};

export type CommunicationFilter = {
    AND?: InputMaybe<CommunicationFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<CommunicationFilter>;
    OR?: InputMaybe<CommunicationFilter>;
    communicationType?: InputMaybe<CommunicationTypeBaseFilterLookup>;
    isRead?: InputMaybe<BoolBaseFilterLookup>;
    sentAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
};

export type CommunicationOrdering = {
    sentAt?: InputMaybe<Ordering>;
};

export enum CommunicationType {
    CALL = 'CALL',
    MESSAGE = 'MESSAGE',
}

export type CommunicationTypeBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<CommunicationType>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<CommunicationType[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Communicator = Clinician | Patient | PhoneNumber;

export enum CommunicatorType {
    CLINICIAN = 'CLINICIAN',
    CLINICIAN_SUPPORT = 'CLINICIAN_SUPPORT',
    PATIENT = 'PATIENT',
    PATIENT_SUPPORT = 'PATIENT_SUPPORT',
    SYSTEM = 'SYSTEM',
    UNKNOWN_PHONE_NUMBER = 'UNKNOWN_PHONE_NUMBER',
}

export type CompatibilityResult = {
    __typename?: 'CompatibilityResult';
    incompatibilities: Incompatibility[];
    isCompatible: Scalars['Boolean']['output'];
};

export type ConfirmedAvailabilityInput = {
    address: AddressInput;
    appointments?: InputMaybe<Appointment[]>;
    patientId: Scalars['UUID']['input'];
    serviceAreaId: Scalars['UUID']['input'];
    serviceBundleIds?: InputMaybe<Scalars['UUID']['input'][]>;
};

export type Contact = {
    __typename?: 'Contact';
    createdAt: Scalars['DateTime']['output'];
    email: Scalars['Email']['output'];
    firstName: Scalars['String']['output'];
    fullName: Scalars['String']['output'];
    isPhoneNumberLandline: Scalars['Boolean']['output'];
    lastName: Scalars['String']['output'];
    phoneNumber: Scalars['PhoneE164']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type Coordinates = {
    __typename?: 'Coordinates';
    latitude: Scalars['String']['output'];
    longitude: Scalars['String']['output'];
};

export type CoordinatesInput = {
    latitude: Scalars['String']['input'];
    longitude: Scalars['String']['input'];
};

export type CounterfactualTimeAssignment = {
    startDatetime: Scalars['DateTime']['input'];
    visitId: Scalars['UUID']['input'];
};

export type CreateClinicianShiftBlockRecurrenceInput = {
    endDatetime: Scalars['DateTime']['input'];
    notes: Scalars['String']['input'];
    recurrence?: InputMaybe<RecurrenceInput>;
    startAddress?: InputMaybe<AddressInput>;
    startDatetime: Scalars['DateTime']['input'];
    timezone: Scalars['Timezone']['input'];
};

export type CreateClinicianShiftRecurrenceInput = {
    endAddress?: InputMaybe<AddressInput>;
    endDatetime: Scalars['DateTime']['input'];
    inheritClinicianMobileTerritories: Scalars['Boolean']['input'];
    inheritClinicianVirtualTerritories: Scalars['Boolean']['input'];
    notes: Scalars['String']['input'];
    recurrence?: InputMaybe<RecurrenceInput>;
    startAddress?: InputMaybe<AddressInput>;
    startDatetime: Scalars['DateTime']['input'];
    timezone: Scalars['Timezone']['input'];
};

export type CreateClinicianTeamInput = {
    clinicianIds: Scalars['UUID']['input'][];
    name: Scalars['NonEmptyString']['input'];
    organizationId: Scalars['UUID']['input'];
};

export type CreateConfirmedVisitFromVisitRequestInput = {
    address: AddressInput;
    patientId?: InputMaybe<Scalars['UUID']['input']>;
    patientUuid?: InputMaybe<Scalars['UUID']['input']>;
    serviceAreaId?: InputMaybe<Scalars['UUID']['input']>;
    serviceAreaUuid?: InputMaybe<Scalars['UUID']['input']>;
    serviceAssignments: ServiceAssignment[];
    serviceIds: Scalars['UUID']['input'][];
    startDatetime: Scalars['DateTime']['input'];
    visitRequestId: Scalars['UUID']['input'];
};

export type CreateRequestToCreateShiftBlockInput = {
    endDatetime: Scalars['DateTime']['input'];
    notes: Scalars['String']['input'];
    recurrence?: InputMaybe<RecurrenceInput>;
    startAddress?: InputMaybe<AddressInput>;
    startDatetime: Scalars['DateTime']['input'];
    timezone: Scalars['Timezone']['input'];
};

export type CreateServiceInput = {
    description: Scalars['String']['input'];
    disciplineIds?: Scalars['UUID']['input'][];
    durationMinutes: Scalars['Int']['input'];
    instructions: Scalars['String']['input'];
    isVirtual: Scalars['Boolean']['input'];
    licenses?: Scalars['String']['input'][];
    name: Scalars['NonEmptyString']['input'];
    organizationId: Scalars['UUID']['input'];
    patientClinicianSexMatchingLevel: MatchingLevel;
    payerIds: Scalars['UUID']['input'][];
    priority: ServicePriority;
    qualificationIdsLegacy: Scalars['UUID']['input'][];
    requiresAllQualifications: Scalars['Boolean']['input'];
};

export type CreateTerritoryInput = {
    name: Scalars['NonEmptyString']['input'];
    organizationId: Scalars['UUID']['input'];
    zipCodes: Scalars['ZipCode']['input'][];
};

export type CreateUnconfirmedVisitFromVisitRequestInput = {
    address: AddressInput;
    patientId?: InputMaybe<Scalars['UUID']['input']>;
    patientUuid?: InputMaybe<Scalars['UUID']['input']>;
    serviceAreaId?: InputMaybe<Scalars['UUID']['input']>;
    serviceAreaUuid?: InputMaybe<Scalars['UUID']['input']>;
    serviceAssignments: ServiceAssignment[];
    serviceIds: Scalars['UUID']['input'][];
    timeslotPreferences: VisitTimeslotPreferenceInput[];
    visitRequestId: Scalars['UUID']['input'];
};

export type CreateVisitInput = {
    address: AddressExpressionInput;
    clinicianAppointments: ClinicianAppointmentInput[];
    disciplineIds: Scalars['UUID']['input'][];
    episodeId?: InputMaybe<Scalars['UUID']['input']>;
    fulfillmentWindow?: InputMaybe<OptionalTimeWindowInput>;
    orderId?: InputMaybe<Scalars['UUID']['input']>;
    outcome?: InputMaybe<VisitOutcome>;
    patientId: Scalars['UUID']['input'];
    priority?: VisitPriority;
    serviceArea: ServiceAreaExpressionInput;
    shouldNotifyPatient?: Scalars['Boolean']['input'];
    startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    state?: InputMaybe<VisitState>;
    tentativeDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateVisitRequestInput = {
    address?: InputMaybe<AddressInput>;
    clinicianAppointments?: InputMaybe<ClinicianAppointmentRequest[]>;
    disciplineIds?: InputMaybe<Scalars['UUID']['input'][]>;
    episodeId?: InputMaybe<Scalars['UUID']['input']>;
    fulfillmentWindow?: InputMaybe<OptionalDateWindowInput>;
    inferAddress?: Scalars['Boolean']['input'];
    inferServiceArea?: Scalars['Boolean']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    orderId?: InputMaybe<Scalars['UUID']['input']>;
    patientId: Scalars['UUID']['input'];
    serviceAreaId?: InputMaybe<Scalars['UUID']['input']>;
    tentativeDate?: InputMaybe<Scalars['Date']['input']>;
    visitBookingNotes?: InputMaybe<Scalars['String']['input']>;
    visitInternalNotes?: InputMaybe<Scalars['String']['input']>;
};

export enum DashboardVariation {
    ELEANOR_HEALTH = 'ELEANOR_HEALTH',
    HOME_HEALTH_DEMO = 'HOME_HEALTH_DEMO',
    HOSPICE_DEMO = 'HOSPICE_DEMO',
    JET_HEALTH = 'JET_HEALTH',
    NORTH_STAR = 'NORTH_STAR',
    NORTH_STAR_UAT = 'NORTH_STAR_UAT',
}

export type DateDateFilterLookup = {
    day?: InputMaybe<IntComparisonFilterLookup>;
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<Scalars['Date']['input']>;
    /** Greater than. Filter will be skipped on `null` value */
    gt?: InputMaybe<Scalars['Date']['input']>;
    /** Greater than or equal to. Filter will be skipped on `null` value */
    gte?: InputMaybe<Scalars['Date']['input']>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<Scalars['Date']['input'][]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
    isoWeekDay?: InputMaybe<IntComparisonFilterLookup>;
    isoYear?: InputMaybe<IntComparisonFilterLookup>;
    /** Less than. Filter will be skipped on `null` value */
    lt?: InputMaybe<Scalars['Date']['input']>;
    /** Less than or equal to. Filter will be skipped on `null` value */
    lte?: InputMaybe<Scalars['Date']['input']>;
    month?: InputMaybe<IntComparisonFilterLookup>;
    quarter?: InputMaybe<IntComparisonFilterLookup>;
    /** Inclusive range test (between) */
    range?: InputMaybe<DateRangeLookup>;
    week?: InputMaybe<IntComparisonFilterLookup>;
    weekDay?: InputMaybe<IntComparisonFilterLookup>;
    year?: InputMaybe<IntComparisonFilterLookup>;
};

export type DateFulfillmentWindow = {
    __typename?: 'DateFulfillmentWindow';
    alignsToMedicareWeek: Scalars['Boolean']['output'];
    endDate: Maybe<Scalars['Date']['output']>;
    endDateAlignsToMedicareWeek: Scalars['Boolean']['output'];
    endDayOfWeek: Maybe<DayOfWeek>;
    startDate: Maybe<Scalars['Date']['output']>;
    startDateAlignsToMedicareWeek: Scalars['Boolean']['output'];
    startDayOfWeek: Maybe<DayOfWeek>;
};

export type DateRangeLookup = {
    end?: InputMaybe<Scalars['Date']['input']>;
    start?: InputMaybe<Scalars['Date']['input']>;
};

export type DateWindow = {
    __typename?: 'DateWindow';
    endDate: Scalars['Date']['output'];
    startDate: Scalars['Date']['output'];
};

export type DateWindowInput = {
    endDate: Scalars['Date']['input'];
    startDate: Scalars['Date']['input'];
};

export type DatetimeDateFilterLookup = {
    day?: InputMaybe<IntComparisonFilterLookup>;
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<Scalars['DateTime']['input']>;
    /** Greater than. Filter will be skipped on `null` value */
    gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** Greater than or equal to. Filter will be skipped on `null` value */
    gte?: InputMaybe<Scalars['DateTime']['input']>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<Scalars['DateTime']['input'][]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
    isoWeekDay?: InputMaybe<IntComparisonFilterLookup>;
    isoYear?: InputMaybe<IntComparisonFilterLookup>;
    /** Less than. Filter will be skipped on `null` value */
    lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** Less than or equal to. Filter will be skipped on `null` value */
    lte?: InputMaybe<Scalars['DateTime']['input']>;
    month?: InputMaybe<IntComparisonFilterLookup>;
    quarter?: InputMaybe<IntComparisonFilterLookup>;
    /** Inclusive range test (between) */
    range?: InputMaybe<DatetimeRangeLookup>;
    week?: InputMaybe<IntComparisonFilterLookup>;
    weekDay?: InputMaybe<IntComparisonFilterLookup>;
    year?: InputMaybe<IntComparisonFilterLookup>;
};

export type DatetimeDatetimeFilterLookup = {
    date?: InputMaybe<IntComparisonFilterLookup>;
    day?: InputMaybe<IntComparisonFilterLookup>;
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<Scalars['DateTime']['input']>;
    /** Greater than. Filter will be skipped on `null` value */
    gt?: InputMaybe<Scalars['DateTime']['input']>;
    /** Greater than or equal to. Filter will be skipped on `null` value */
    gte?: InputMaybe<Scalars['DateTime']['input']>;
    hour?: InputMaybe<IntComparisonFilterLookup>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<Scalars['DateTime']['input'][]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
    isoWeekDay?: InputMaybe<IntComparisonFilterLookup>;
    isoYear?: InputMaybe<IntComparisonFilterLookup>;
    /** Less than. Filter will be skipped on `null` value */
    lt?: InputMaybe<Scalars['DateTime']['input']>;
    /** Less than or equal to. Filter will be skipped on `null` value */
    lte?: InputMaybe<Scalars['DateTime']['input']>;
    minute?: InputMaybe<IntComparisonFilterLookup>;
    month?: InputMaybe<IntComparisonFilterLookup>;
    quarter?: InputMaybe<IntComparisonFilterLookup>;
    /** Inclusive range test (between) */
    range?: InputMaybe<DatetimeRangeLookup>;
    second?: InputMaybe<IntComparisonFilterLookup>;
    time?: InputMaybe<IntComparisonFilterLookup>;
    week?: InputMaybe<IntComparisonFilterLookup>;
    weekDay?: InputMaybe<IntComparisonFilterLookup>;
    year?: InputMaybe<IntComparisonFilterLookup>;
};

export type DatetimeRangeLookup = {
    end?: InputMaybe<Scalars['DateTime']['input']>;
    start?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum DayOfWeek {
    FRIDAY = 'FRIDAY',
    MONDAY = 'MONDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY',
    THURSDAY = 'THURSDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
}

export type DayOfWeekTimeslot = {
    __typename?: 'DayOfWeekTimeslot';
    day: PatientTimeslotDayOfWeek;
    endTime: Scalars['Time']['output'];
    startTime: Scalars['Time']['output'];
};

export type DayOfWeekTimeslotFilter = {
    AND?: InputMaybe<DayOfWeekTimeslotFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<DayOfWeekTimeslotFilter>;
    OR?: InputMaybe<DayOfWeekTimeslotFilter>;
    day?: InputMaybe<StrBaseFilterLookup>;
    endTime?: InputMaybe<TimeTimeFilterLookup>;
    startTime?: InputMaybe<TimeTimeFilterLookup>;
};

export type DayOfWeekTimeslotInput = {
    day: PatientTimeslotDayOfWeek;
    endTime: Scalars['Time']['input'];
    startTime: Scalars['Time']['input'];
};

export type DayOfWeekTimeslotOrdering = {
    day?: InputMaybe<Ordering>;
    endTime?: InputMaybe<Ordering>;
    startTime?: InputMaybe<Ordering>;
};

export type DeactivateClinicianInput = {
    clinicianId: Scalars['UUID']['input'];
};

export type DecisionSupportQuery = {
    __typename?: 'DecisionSupportQuery';
    capacityForSingleServiceByDate: Maybe<CapacityForService[]>;
    visitRequests: Maybe<BulkVisitRequestsDecisionSupport>;
    visits: Maybe<BulkVisitsDecisionSupport>;
};

export type DecisionSupportQueryCapacityForSingleServiceByDateArgs = {
    address: AddressInput;
    clinicianFilters?: InputMaybe<ClinicianFilter>;
    dateRange: DateWindowInput;
    serviceFilters: ServiceFilter;
};

export type DecisionSupportQueryVisitRequestsArgs = {
    filters?: InputMaybe<VisitRequestFilter>;
};

export type DecisionSupportQueryVisitsArgs = {
    filters?: InputMaybe<VisitFilter>;
};

export type DeleteClinicianShiftBlockOccurrenceInput = {
    occurrenceStartDatetime: Scalars['DateTime']['input'];
    scope: RecurrenceMutationScope;
    shiftBlockRecurrenceId: Scalars['UUID']['input'];
};

export type DeleteClinicianShiftBlockRecurrenceInput = {
    id: Scalars['UUID']['input'];
    occurrenceStartDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    scope: RecurrenceMutationScope;
};

export type DeleteClinicianTeamInput = {
    clinicianTeamId: Scalars['UUID']['input'];
    organizationId: Scalars['UUID']['input'];
};

export type DeleteClinicianTeamResult = {
    __typename?: 'DeleteClinicianTeamResult';
    id: Scalars['UUID']['output'];
};

export type DeleteOrderInput = {
    orderId: Scalars['UUID']['input'];
};

export type DeletePatientTimeslotPreferencesInput = {
    patientId: Scalars['UUID']['input'];
};

export type DeleteShiftBlockOccurrenceResult = {
    __typename?: 'DeleteShiftBlockOccurrenceResult';
    editedShiftBlockRecurrence: Maybe<ShiftBlockRecurrence>;
};

export type DeleteShiftBlockRecurrenceResult = {
    __typename?: 'DeleteShiftBlockRecurrenceResult';
    editedShiftBlockRecurrence: Maybe<ShiftBlockRecurrence>;
};

export type DeleteTerritoryInput = {
    territoryId: Scalars['UUID']['input'];
};

export type DenyRequestToCreateShiftBlockInput = {
    denialReason: Scalars['String']['input'];
    id: Scalars['UUID']['input'];
};

export type Discipline = {
    __typename?: 'Discipline';
    clinicians: Maybe<ClinicianPaginatedList>;
    code: Scalars['String']['output'];
    createdAt: Scalars['DateTime']['output'];
    displayName: Scalars['String']['output'];
    externalIds: ExternalId[];
    id: Scalars['UUID']['output'];
    licenses: License[];
    name: Maybe<Scalars['String']['output']>;
    orders: Maybe<OrderPaginatedList>;
    organization: Organization;
    services: Maybe<ServicePaginatedList>;
    updatedAt: Scalars['DateTime']['output'];
    visitRequests: Maybe<VisitRequestPaginatedList>;
    visits: Maybe<VisitPaginatedList>;
};

export type DisciplineCliniciansArgs = {
    filters?: InputMaybe<ClinicianFilter>;
    ordering?: InputMaybe<ClinicianOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type DisciplineOrdersArgs = {
    filters?: InputMaybe<OrderFilter>;
    ordering?: InputMaybe<OrderOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type DisciplineServicesArgs = {
    filters?: InputMaybe<ServiceFilter>;
    ordering?: InputMaybe<ServiceOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type DisciplineVisitRequestsArgs = {
    filters?: InputMaybe<VisitRequestFilter>;
    ordering?: InputMaybe<VisitRequestOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type DisciplineVisitsArgs = {
    filters?: InputMaybe<VisitFilter>;
    ordering?: InputMaybe<VisitOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type DisciplineFilter = {
    AND?: InputMaybe<DisciplineFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<DisciplineFilter>;
    OR?: InputMaybe<DisciplineFilter>;
    code?: InputMaybe<StrBaseFilterLookup>;
    displayName?: InputMaybe<StrFilterLookup>;
    externalIds?: InputMaybe<ExternalIdFilter>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    name?: InputMaybe<StrFilterLookup>;
    orders?: InputMaybe<OrderFilter>;
    organization?: InputMaybe<OrganizationFilter>;
};

export type DisciplineOrdering = {
    code?: InputMaybe<Ordering>;
    displayName?: InputMaybe<Ordering>;
    name?: InputMaybe<Ordering>;
    organization?: InputMaybe<OrganizationOrdering>;
};

export type DisciplinePaginatedList = {
    __typename?: 'DisciplinePaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: Discipline[];
    totalCount: Scalars['Int']['output'];
};

export type DiscontinueOrderInput = {
    cancelRemainingUnscheduledVisits?: Scalars['Boolean']['input'];
    orderId: Scalars['UUID']['input'];
};

export type Document = {
    __typename?: 'Document';
    createdAt: Scalars['DateTime']['output'];
    documentType: DocumentType;
    downloadLink: Scalars['String']['output'];
    id: Scalars['UUID']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export enum DocumentType {
    CONSENT = 'CONSENT',
    IMMUNIZATION_RECORD = 'IMMUNIZATION_RECORD',
    PATIENT_UPLOAD = 'PATIENT_UPLOAD',
    PRESCRIPTION = 'PRESCRIPTION',
    REQUISITION = 'REQUISITION',
    RESULT = 'RESULT',
    SAMPLE = 'SAMPLE',
    SHIPPING_LABEL = 'SHIPPING_LABEL',
    UNKNOWN = 'UNKNOWN',
}

export enum DropReason {
    BLOCKED = 'BLOCKED',
    DELETED = 'DELETED',
    DROPPED = 'DROPPED',
    NONE = 'NONE',
}

export type EditClinicianShiftBlockRecurrenceInput = {
    endDatetime: Scalars['DateTime']['input'];
    id: Scalars['UUID']['input'];
    notes: Scalars['String']['input'];
    occurrenceStartDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    recurrence?: InputMaybe<RecurrenceInput>;
    scope: RecurrenceMutationScope;
    startAddress?: InputMaybe<AddressInput>;
    startDatetime: Scalars['DateTime']['input'];
    timezone: Scalars['Timezone']['input'];
};

export type EditClinicianShiftRecurrenceInput = {
    endAddress?: InputMaybe<AddressInput>;
    endDatetime: Scalars['DateTime']['input'];
    id: Scalars['UUID']['input'];
    inheritClinicianMobileTerritories: Scalars['Boolean']['input'];
    inheritClinicianVirtualTerritories: Scalars['Boolean']['input'];
    notes: Scalars['String']['input'];
    occurrenceStartDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    recurrence?: InputMaybe<RecurrenceInput>;
    scope: RecurrenceMutationScope;
    startAddress?: InputMaybe<AddressInput>;
    startDatetime: Scalars['DateTime']['input'];
    timezone: Scalars['Timezone']['input'];
};

export type EditClinicianTeamInput = {
    clinicianIds: Scalars['UUID']['input'][];
    clinicianTeamId: Scalars['UUID']['input'];
    name: Scalars['NonEmptyString']['input'];
    organizationId: Scalars['UUID']['input'];
};

export type EditEpisodeNotesInput = {
    episodeId: Scalars['UUID']['input'];
    notes?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type EditPatientNotesInput = {
    notes: Scalars['String']['input'];
    patientId: Scalars['UUID']['input'];
};

export type EditRequestToCreateShiftBlockInput = {
    endDatetime: Scalars['DateTime']['input'];
    id: Scalars['UUID']['input'];
    notes: Scalars['String']['input'];
    occurrenceStartDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    recurrence?: InputMaybe<RecurrenceInput>;
    scope: RecurrenceMutationScope;
    startAddress?: InputMaybe<AddressInput>;
    startDatetime: Scalars['DateTime']['input'];
    timezone: Scalars['Timezone']['input'];
};

export type EditServiceInput = {
    description: Scalars['String']['input'];
    disciplineIds: Scalars['UUID']['input'][];
    durationMinutes: Scalars['Int']['input'];
    instructions: Scalars['String']['input'];
    licenses?: Scalars['String']['input'][];
    name: Scalars['NonEmptyString']['input'];
    organizationId: Scalars['UUID']['input'];
    patientClinicianSexMatchingLevel: MatchingLevel;
    payerIds: Scalars['UUID']['input'][];
    priority: ServicePriority;
    qualificationIdsLegacy: Scalars['UUID']['input'][];
    requiresAllQualifications: Scalars['Boolean']['input'];
    serviceId: Scalars['UUID']['input'];
};

export type EditShiftBlockRecurrenceResult = {
    __typename?: 'EditShiftBlockRecurrenceResult';
    createdShiftBlockRecurrence: Maybe<ShiftBlockRecurrence>;
    editedShiftBlockRecurrence: Maybe<ShiftBlockRecurrence>;
};

export type EditShiftRecurrenceResult = {
    __typename?: 'EditShiftRecurrenceResult';
    createdShiftRecurrence: Maybe<ShiftRecurrence>;
    editedShiftRecurrence: Maybe<ShiftRecurrence>;
    impactedVisits: Visit[];
};

export type EditTerritoryInput = {
    name: Scalars['NonEmptyString']['input'];
    territoryId: Scalars['UUID']['input'];
};

export type EditVisitRequestInput = {
    address?: InputMaybe<AddressInput>;
    appointments?: InputMaybe<ClinicianAppointmentRequest[]>;
    clinicId?: InputMaybe<Scalars['UUID']['input']>;
    fulfillmentWindow?: InputMaybe<OptionalDateWindowInput>;
    notes?: InputMaybe<Scalars['String']['input']>;
    priority?: VisitPriority;
    state?: VisitRequestState;
    tentativeDate?: InputMaybe<Scalars['Date']['input']>;
    visitBookingNotes?: InputMaybe<Scalars['String']['input']>;
    visitInternalNotes?: InputMaybe<Scalars['String']['input']>;
    visitRequestId: Scalars['UUID']['input'];
};

export type Eligibility = {
    __typename?: 'Eligibility';
    byClinician: ClinicianEligibility[];
    byResource: ResourceEligibility[];
    metadata: EligibilityMetadata;
};

export type EligibilityBoundResourceForClinician = {
    __typename?: 'EligibilityBoundResourceForClinician';
    eligibilityBoundResource: ServiceBundlePositionClinicianAppointment;
    isEligible: Scalars['Boolean']['output'];
};

export type EligibilityFilter = {
    clinician?: InputMaybe<ClinicianFilter>;
    includeStrictlyEligibleOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EligibilityForServiceBundleInput = {
    address: AddressInput;
    organizationId: Scalars['UUID']['input'];
    serviceAreaId: Scalars['UUID']['input'];
    serviceBundleIds?: InputMaybe<Scalars['UUID']['input'][]>;
    serviceIds?: InputMaybe<Scalars['UUID']['input'][]>;
};

export type EligibilityMetadata = {
    __typename?: 'EligibilityMetadata';
    hasEligible: Scalars['Boolean']['output'];
};

export type Encounter = {
    __typename?: 'Encounter';
    clinicianAppointment: Maybe<ClinicianAppointment>;
    id: Scalars['ID']['output'];
    isCompleted: Maybe<Scalars['Boolean']['output']>;
    service: Service;
    visit: Visit;
};

export type EpisodeOfCare = {
    __typename?: 'EpisodeOfCare';
    createdAt: Scalars['Date']['output'];
    disciplines: Maybe<DisciplinePaginatedList>;
    endDate: Maybe<Scalars['Date']['output']>;
    externalIds: ExternalId[];
    id: Scalars['UUID']['output'];
    isActive: Scalars['Boolean']['output'];
    isActiveByDate: Scalars['Boolean']['output'];
    isActiveField: Scalars['Boolean']['output'];
    notes: Maybe<Scalars['String']['output']>;
    numberInSequence: Maybe<Scalars['Int']['output']>;
    orders: Maybe<OrderPaginatedList>;
    patient: Patient;
    permissions: EpisodeOfCarePermissions;
    referralDate: Maybe<Scalars['Date']['output']>;
    startDate: Maybe<Scalars['Date']['output']>;
    startOfCareDate: Maybe<Scalars['Date']['output']>;
    syncStatus: Maybe<SyncStatus>;
    updatedAt: Scalars['Date']['output'];
    visitRequests: Maybe<VisitRequestPaginatedList>;
    visits: Maybe<VisitPaginatedList>;
};

export type EpisodeOfCareDisciplinesArgs = {
    filters?: InputMaybe<DisciplineFilter>;
    ordering?: InputMaybe<DisciplineOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type EpisodeOfCareOrdersArgs = {
    filters?: InputMaybe<OrderFilter>;
    ordering?: InputMaybe<OrderOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type EpisodeOfCareVisitRequestsArgs = {
    filters?: InputMaybe<VisitRequestFilter>;
    ordering?: InputMaybe<VisitRequestOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type EpisodeOfCareVisitsArgs = {
    filters?: InputMaybe<VisitFilter>;
    ordering?: InputMaybe<VisitOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type EpisodeOfCareFilter = {
    AND?: InputMaybe<EpisodeOfCareFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<EpisodeOfCareFilter>;
    OR?: InputMaybe<EpisodeOfCareFilter>;
    createdAt?: InputMaybe<DateDateFilterLookup>;
    endDate?: InputMaybe<DateDateFilterLookup>;
    externalIds?: InputMaybe<ExternalIdFilter>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    /** @deprecated Use is_active_by_date instead, this field's meaning will be changed in a future release. */
    isActive?: InputMaybe<BoolBaseFilterLookup>;
    isActiveByDate?: InputMaybe<BoolBaseFilterLookup>;
    isActiveField?: InputMaybe<BoolBaseFilterLookup>;
    notes?: InputMaybe<StrFilterLookup>;
    numberInSequence?: InputMaybe<IntComparisonFilterLookup>;
    orders?: InputMaybe<OrderFilter>;
    patient?: InputMaybe<PatientFilter>;
    referralDate?: InputMaybe<DateDateFilterLookup>;
    startDate?: InputMaybe<DateDateFilterLookup>;
    startOfCareDate?: InputMaybe<DateDateFilterLookup>;
    syncStatus?: InputMaybe<SyncStatusFilter>;
    updatedAt?: InputMaybe<DateDateFilterLookup>;
    visitRequests?: InputMaybe<VisitRequestFilter>;
    visits?: InputMaybe<VisitFilter>;
};

export type EpisodeOfCareOrdering = {
    createdAt?: InputMaybe<Ordering>;
    endDate?: InputMaybe<Ordering>;
    numberInSequence?: InputMaybe<Ordering>;
    orders?: InputMaybe<OrderOrdering>;
    patient?: InputMaybe<PatientOrdering>;
    referralDate?: InputMaybe<Ordering>;
    startDate?: InputMaybe<Ordering>;
    startOfCareDate?: InputMaybe<Ordering>;
    updatedAt?: InputMaybe<Ordering>;
    visitRequests?: InputMaybe<VisitRequestOrdering>;
    visits?: InputMaybe<VisitOrdering>;
};

export type EpisodeOfCarePaginatedList = {
    __typename?: 'EpisodeOfCarePaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: EpisodeOfCare[];
    totalCount: Scalars['Int']['output'];
};

export type EpisodeOfCarePermissions = {
    __typename?: 'EpisodeOfCarePermissions';
    edit: Scalars['Boolean']['output'];
    editNotes: Scalars['Boolean']['output'];
    id: Scalars['UUID']['output'];
    viewNotes: Scalars['Boolean']['output'];
};

export type ExternalId = {
    __typename?: 'ExternalId';
    clinicianAppointments: Maybe<ClinicianAppointment[]>;
    clinicians: Maybe<Clinician[]>;
    createdAt: Scalars['DateTime']['output'];
    disciplines: Maybe<Discipline[]>;
    episodes: Maybe<EpisodeOfCare[]>;
    metadata: Maybe<Scalars['JSON']['output']>;
    optionValues: Maybe<OptionValue[]>;
    orders: Maybe<Order[]>;
    organization: Organization;
    patients: Maybe<Patient[]>;
    payers: Maybe<Payer[]>;
    serviceAreas: Maybe<ServiceArea[]>;
    services: Maybe<Service[]>;
    system: Scalars['String']['output'];
    type: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTime']['output'];
    value: Scalars['String']['output'];
    visitRequests: Maybe<VisitRequest[]>;
    visits: Maybe<Visit[]>;
};

export type ExternalIdFilter = {
    AND?: InputMaybe<ExternalIdFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<ExternalIdFilter>;
    OR?: InputMaybe<ExternalIdFilter>;
    metadata?: InputMaybe<JsonjsonFilterLookup>;
    organization?: InputMaybe<OrganizationFilter>;
    system?: InputMaybe<StrFilterLookup>;
    type?: InputMaybe<StrFilterLookup>;
    value?: InputMaybe<StrFilterLookup>;
};

export type FeatureFlag = {
    __typename?: 'FeatureFlag';
    enabled: Scalars['Boolean']['output'];
    id: Scalars['String']['output'];
};

export type FinalizeRoutesResult = {
    __typename?: 'FinalizeRoutesResult';
    finalizedVisits: Visit[];
    solutionTraceId: Maybe<Scalars['UUID']['output']>;
};

export type GenerateOrderVisitRequestsInput = {
    numToGenerate: Scalars['PositiveInt']['input'];
    orderId: Scalars['UUID']['input'];
};

export type GenerateOrderVisitRequestsOutput = {
    __typename?: 'GenerateOrderVisitRequestsOutput';
    newVisitRequests: VisitRequest[];
    order: Order;
};

export type GenerateRemainingOrderVisitRequestsInput = {
    countInactiveVisits?: Scalars['Boolean']['input'];
    orderId: Scalars['UUID']['input'];
};

export type Incompatibility = {
    __typename?: 'Incompatibility';
    description: Scalars['String']['output'];
    type: IncompatibilityType;
};

export enum IncompatibilityType {
    CLINICIAN_ACTIVE = 'CLINICIAN_ACTIVE',
    CLINICIAN_ADDRESS_SERVICESET_GEOGRAPHY = 'CLINICIAN_ADDRESS_SERVICESET_GEOGRAPHY',
    CLINICIAN_PATIENT_PAYER = 'CLINICIAN_PATIENT_PAYER',
    CLINICIAN_PATIENT_SERVICESET_SEX = 'CLINICIAN_PATIENT_SERVICESET_SEX',
    CLINICIAN_SERVICESET_LICENSE = 'CLINICIAN_SERVICESET_LICENSE',
    CLINICIAN_SERVICESET_PAYER = 'CLINICIAN_SERVICESET_PAYER',
    CLINICIAN_SERVICESET_QUALIFICATION = 'CLINICIAN_SERVICESET_QUALIFICATION',
    SERVICESET_ADDRESS_GEOGRAPHY = 'SERVICESET_ADDRESS_GEOGRAPHY',
    SERVICESET_PATIENT_PAYER = 'SERVICESET_PATIENT_PAYER',
}

export type IntComparisonFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<Scalars['Int']['input']>;
    /** Greater than. Filter will be skipped on `null` value */
    gt?: InputMaybe<Scalars['Int']['input']>;
    /** Greater than or equal to. Filter will be skipped on `null` value */
    gte?: InputMaybe<Scalars['Int']['input']>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<Scalars['Int']['input'][]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
    /** Less than. Filter will be skipped on `null` value */
    lt?: InputMaybe<Scalars['Int']['input']>;
    /** Less than or equal to. Filter will be skipped on `null` value */
    lte?: InputMaybe<Scalars['Int']['input']>;
    /** Inclusive range test (between) */
    range?: InputMaybe<IntRangeLookup>;
};

export type IntRangeLookup = {
    end?: InputMaybe<Scalars['Int']['input']>;
    start?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFilterLookup = {
    /** Case-sensitive containment test. Filter will be skipped on `null` value */
    contains?: InputMaybe<Scalars['JSON']['input']>;
    /** Case-sensitive ends-with. Filter will be skipped on `null` value */
    endsWith?: InputMaybe<Scalars['JSON']['input']>;
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<Scalars['JSON']['input']>;
    /** Case-insensitive containment test. Filter will be skipped on `null` value */
    iContains?: InputMaybe<Scalars['JSON']['input']>;
    /** Case-insensitive ends-with. Filter will be skipped on `null` value */
    iEndsWith?: InputMaybe<Scalars['JSON']['input']>;
    /** Case-insensitive exact match. Filter will be skipped on `null` value */
    iExact?: InputMaybe<Scalars['JSON']['input']>;
    /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
    iRegex?: InputMaybe<Scalars['JSON']['input']>;
    /** Case-insensitive starts-with. Filter will be skipped on `null` value */
    iStartsWith?: InputMaybe<Scalars['JSON']['input']>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<Scalars['JSON']['input'][]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
    /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
    regex?: InputMaybe<Scalars['JSON']['input']>;
    /** Case-sensitive starts-with. Filter will be skipped on `null` value */
    startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type JsonjsonFilterLookup = {
    contains?: InputMaybe<Scalars['JSON']['input']>;
    exact?: InputMaybe<Scalars['JSON']['input']>;
    hasAnyKeys?: InputMaybe<Scalars['String']['input'][]>;
    hasKey?: InputMaybe<Scalars['String']['input']>;
    hasKeys?: InputMaybe<Scalars['String']['input'][]>;
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum Language {
    ARABIC = 'ARABIC',
    CHINESE = 'CHINESE',
    ENGLISH = 'ENGLISH',
    FRENCH = 'FRENCH',
    GERMAN = 'GERMAN',
    KHMER = 'KHMER',
    KOREAN = 'KOREAN',
    PERSIAN = 'PERSIAN',
    RUSSIAN = 'RUSSIAN',
    SPANISH = 'SPANISH',
    TAGALOG = 'TAGALOG',
    URDU = 'URDU',
    VIETNAMESE = 'VIETNAMESE',
}

export enum License {
    AIDE = 'AIDE',
    APN = 'APN',
    APRN = 'APRN',
    ARNP = 'ARNP',
    CHW = 'CHW',
    CMA = 'CMA',
    CNA = 'CNA',
    CNP = 'CNP',
    COTA = 'COTA',
    CPT = 'CPT',
    CRNP = 'CRNP',
    DNP = 'DNP',
    DO = 'DO',
    FNP = 'FNP',
    HA = 'HA',
    HCN = 'HCN',
    HHA = 'HHA',
    LADAC = 'LADAC',
    LADC = 'LADC',
    LCAS = 'LCAS',
    LCMHC = 'LCMHC',
    LCPC = 'LCPC',
    LCSW = 'LCSW',
    LICDC = 'LICDC',
    LICSW = 'LICSW',
    LISW = 'LISW',
    LMHC = 'LMHC',
    LPC = 'LPC',
    LPN = 'LPN',
    LT = 'LT',
    LVN = 'LVN',
    MA = 'MA',
    MD = 'MD',
    MSN = 'MSN',
    MSW = 'MSW',
    MT = 'MT',
    NP = 'NP',
    NP_S = 'NP_S',
    OT = 'OT',
    PA = 'PA',
    PASUP = 'PASUP',
    PA_C = 'PA_C',
    PHD = 'PHD',
    PMHNP = 'PMHNP',
    PMHNP_BC = 'PMHNP_BC',
    PSYD = 'PSYD',
    PT = 'PT',
    PTA = 'PTA',
    P_MD = 'P_MD',
    RMA = 'RMA',
    RN = 'RN',
    SCA = 'SCA',
    SLP = 'SLP',
    ST = 'ST',
    SUDP = 'SUDP',
}

export type LockTerritoryInput = {
    territoryId: Scalars['UUID']['input'];
};

export type MarkVisitAsIncompleteInput = {
    clinicianAppointmentId?: InputMaybe<Scalars['UUID']['input']>;
    incompleteVisitNotes?: InputMaybe<Scalars['String']['input']>;
    outcomeNotes?: InputMaybe<Scalars['String']['input']>;
    requiresReschedule?: InputMaybe<Scalars['Boolean']['input']>;
    visitId: Scalars['UUID']['input'];
    visitOutcome: VisitOutcome;
};

export type MarkVisitAsMissedInput = {
    missedVisitNotes?: InputMaybe<Scalars['String']['input']>;
    requiresReschedule?: InputMaybe<Scalars['Boolean']['input']>;
    visitId: Scalars['UUID']['input'];
};

export enum MatchingLevel {
    BEST_EFFORT = 'BEST_EFFORT',
    IGNORE = 'IGNORE',
    STRICT = 'STRICT',
}

export type Message = {
    __typename?: 'Message';
    body: Scalars['String']['output'];
    isRead: Scalars['Boolean']['output'];
    mediaUrls: Scalars['String']['output'][];
};

export type Mutation = {
    __typename?: 'Mutation';
    addAssociationsToOrder: OrderAddAssociationsResult;
    addZipCodesToTerritory: Maybe<Territory>;
    archiveTerritory: Maybe<Territory>;
    betaClaimFromWaitlist: Maybe<Visit>;
    betaCreateConfirmedVisit: Visit;
    betaCreateUnconfirmedVisit: Visit;
    betaEditClinicianAppointment: Maybe<BetaEditClinicianAppointmentSuccessResult>;
    betaEditVisit: Maybe<Visit>;
    betaFinalizeRoutes: Visit[];
    betaUnclaimFromWaitlist: Maybe<Visit>;
    bookUnscheduledVisit: Maybe<Visit>;
    bulkPromoteVisitRequests: PromoteVisitRequestBulkResponse;
    bulkUpdateVisitRequestAppointmentClinicianAssignment: BulkUpdateVisitRequestAppointmentClinicianAssignmentResponse;
    bulkUpdateVisitRequestClinicianAppointmentServices: BulkUpdateVisitRequestClinicianAppointmentServicesResponse;
    bulkUpdateVisitRequestTentativeDate: BulkUpdateVisitRequestTentativeDateResponse;
    cancelClinicianShiftOccurrence: Maybe<CancelShiftOccurrenceResult>;
    cancelClinicianShiftRecurrence: Maybe<CancelShiftRecurrenceResult>;
    cancelVisitRequest: VisitRequest;
    clinicianSendSystemMessageToPatient: VisitCommunications;
    createClinicianShiftBlockRecurrence: Maybe<ShiftBlockRecurrence>;
    createClinicianShiftRecurrence: Maybe<ShiftRecurrence>;
    createClinicianTeam: Maybe<ClinicianTeam>;
    createConfirmedVisitFromVisitRequest: Visit;
    createService: Maybe<Service>;
    createTerritory: Maybe<Territory>;
    createUnconfirmedVisitFromVisitRequest: Visit;
    createVisit: Visit;
    /** Create a new visit request. Can optionally be associated with an order by providing order_id. */
    createVisitRequest: VisitRequest;
    deactivateClinician: Clinician;
    deleteClinicianShiftBlockOccurrence: Maybe<DeleteShiftBlockOccurrenceResult>;
    deleteClinicianShiftBlockRecurrence: Maybe<DeleteShiftBlockRecurrenceResult>;
    deleteClinicianTeam: DeleteClinicianTeamResult;
    deleteOrder: Scalars['Boolean']['output'];
    deletePatientTimeslotPreferences: Scalars['Boolean']['output'];
    deleteTerritory: Maybe<Scalars['UUID']['output']>;
    deleteVisitRequest: Scalars['Boolean']['output'];
    discontinueOrder: Order;
    editClinicianShiftBlockRecurrence: Maybe<EditShiftBlockRecurrenceResult>;
    editClinicianShiftRecurrence: Maybe<EditShiftRecurrenceResult>;
    editClinicianTeam: Maybe<ClinicianTeam>;
    editEpisodeNotes: EpisodeOfCare;
    editPatientNotes: Patient;
    editService: Maybe<Service>;
    editTerritory: Maybe<Territory>;
    editVisitRequest: VisitRequest;
    finalizeRoutes: Maybe<FinalizeRoutesResult>;
    generateOrderVisitRequests: GenerateOrderVisitRequestsOutput;
    generateRemainingOrderVisitRequests: GenerateOrderVisitRequestsOutput;
    lockTerritory: Maybe<Territory>;
    markVisitAsIncomplete: Maybe<Visit>;
    markVisitAsMissed: Maybe<Visit>;
    pauseOrder: Order;
    promoteVisitRequest: VisitRequest;
    removeAssociationsFromOrder: OrderRemoveAssociationsResult;
    removeZipCodesFromTerritory: Maybe<Territory>;
    resend2faQrcodeEmails: User;
    resendClinicianSetupEmails: Clinician;
    resendUserPasswordResetEmails: User;
    scheduleChangeRequests: ScheduleChangeRequestMutations;
    scheduleUnscheduledVisit: Maybe<Visit>;
    sendClinicianSupportMessage: ClinicianCommunications;
    sendMessageToPatientFromAssignedClinician: VisitCommunications;
    sendPatientSupportMessage: PatientCommunications;
    setPatientCommsPreferences: Patient;
    setPatientTimeslotPreferences: Patient;
    startClinicianSupportCall: StartClinicianSupportCallResponse;
    startPatientSupportCall: StartPatientSupportCallResponse;
    syncAllPatientResources: Patient;
    triggerClinicianWebhook: Clinician;
    triggerEpisodeOfCareWebhook: EpisodeOfCare;
    triggerPatientWebhook: Patient;
    triggerVisitRequestWebhook: VisitRequest;
    triggerVisitWebhook: Visit;
    unarchiveTerritory: Maybe<Territory>;
    uncancelVisitRequest: VisitRequest;
    unlockTerritory: Maybe<Territory>;
    unpauseOrder: Order;
    updateVisitRequestAppointmentClinicianAssignment: VisitRequest;
    updateVisitRequestClinicianAppointmentServices: VisitRequest;
    updateVisitRequestTentativeDate: VisitRequest;
};

export type MutationAddAssociationsToOrderArgs = {
    input: OrderAssociationInput;
};

export type MutationAddZipCodesToTerritoryArgs = {
    input: AddZipCodesToTerritoryInput;
};

export type MutationArchiveTerritoryArgs = {
    input: ArchiveTerritoryInput;
};

export type MutationBetaClaimFromWaitlistArgs = {
    visitId: Scalars['UUID']['input'];
};

export type MutationBetaCreateConfirmedVisitArgs = {
    input: BetaCreateConfirmedVisitInput;
};

export type MutationBetaCreateUnconfirmedVisitArgs = {
    input: BetaCreateUnconfirmedVisitInput;
};

export type MutationBetaEditClinicianAppointmentArgs = {
    input: BetaEditClinicianAppointmentInput;
};

export type MutationBetaEditVisitArgs = {
    input: BetaEditVisitInput;
};

export type MutationBetaFinalizeRoutesArgs = {
    input: BetaFinalizeRoutesInput;
};

export type MutationBetaUnclaimFromWaitlistArgs = {
    visitId: Scalars['UUID']['input'];
};

export type MutationBookUnscheduledVisitArgs = {
    input: BookUnscheduledVisitInput;
};

export type MutationBulkPromoteVisitRequestsArgs = {
    input: BulkPromoteVisitRequestsInput;
};

export type MutationBulkUpdateVisitRequestAppointmentClinicianAssignmentArgs = {
    input: BulkUpdateVisitRequestAppointmentClinicianAssignmentInput;
};

export type MutationBulkUpdateVisitRequestClinicianAppointmentServicesArgs = {
    input: BulkUpdateVisitRequestClinicianAppointmentServicesInput;
};

export type MutationBulkUpdateVisitRequestTentativeDateArgs = {
    input: BulkUpdateVisitRequestTentativeDateInput;
};

export type MutationCancelClinicianShiftOccurrenceArgs = {
    input: CancelClinicianShiftOccurrenceInput;
};

export type MutationCancelClinicianShiftRecurrenceArgs = {
    input: CancelClinicianShiftRecurrenceInput;
};

export type MutationCancelVisitRequestArgs = {
    visitRequestId: Scalars['UUID']['input'];
};

export type MutationClinicianSendSystemMessageToPatientArgs = {
    input: ClinicianSendSystemMessageToPatientInput;
};

export type MutationCreateClinicianShiftBlockRecurrenceArgs = {
    input: CreateClinicianShiftBlockRecurrenceInput;
};

export type MutationCreateClinicianShiftRecurrenceArgs = {
    input: CreateClinicianShiftRecurrenceInput;
};

export type MutationCreateClinicianTeamArgs = {
    input: CreateClinicianTeamInput;
};

export type MutationCreateConfirmedVisitFromVisitRequestArgs = {
    input: CreateConfirmedVisitFromVisitRequestInput;
};

export type MutationCreateServiceArgs = {
    input: CreateServiceInput;
};

export type MutationCreateTerritoryArgs = {
    input: CreateTerritoryInput;
};

export type MutationCreateUnconfirmedVisitFromVisitRequestArgs = {
    input: CreateUnconfirmedVisitFromVisitRequestInput;
};

export type MutationCreateVisitArgs = {
    input: CreateVisitInput;
};

export type MutationCreateVisitRequestArgs = {
    input: CreateVisitRequestInput;
};

export type MutationDeactivateClinicianArgs = {
    input: DeactivateClinicianInput;
};

export type MutationDeleteClinicianShiftBlockOccurrenceArgs = {
    input: DeleteClinicianShiftBlockOccurrenceInput;
};

export type MutationDeleteClinicianShiftBlockRecurrenceArgs = {
    input: DeleteClinicianShiftBlockRecurrenceInput;
};

export type MutationDeleteClinicianTeamArgs = {
    input: DeleteClinicianTeamInput;
};

export type MutationDeleteOrderArgs = {
    input: DeleteOrderInput;
};

export type MutationDeletePatientTimeslotPreferencesArgs = {
    input: DeletePatientTimeslotPreferencesInput;
};

export type MutationDeleteTerritoryArgs = {
    input: DeleteTerritoryInput;
};

export type MutationDeleteVisitRequestArgs = {
    visitRequestId: Scalars['UUID']['input'];
};

export type MutationDiscontinueOrderArgs = {
    input: DiscontinueOrderInput;
};

export type MutationEditClinicianShiftBlockRecurrenceArgs = {
    input: EditClinicianShiftBlockRecurrenceInput;
};

export type MutationEditClinicianShiftRecurrenceArgs = {
    input: EditClinicianShiftRecurrenceInput;
};

export type MutationEditClinicianTeamArgs = {
    input: EditClinicianTeamInput;
};

export type MutationEditEpisodeNotesArgs = {
    input: EditEpisodeNotesInput;
};

export type MutationEditPatientNotesArgs = {
    input: EditPatientNotesInput;
};

export type MutationEditServiceArgs = {
    input: EditServiceInput;
};

export type MutationEditTerritoryArgs = {
    input: EditTerritoryInput;
};

export type MutationEditVisitRequestArgs = {
    input: EditVisitRequestInput;
};

export type MutationFinalizeRoutesArgs = {
    input: BetaFinalizeRoutesInput;
};

export type MutationGenerateOrderVisitRequestsArgs = {
    input: GenerateOrderVisitRequestsInput;
};

export type MutationGenerateRemainingOrderVisitRequestsArgs = {
    input: GenerateRemainingOrderVisitRequestsInput;
};

export type MutationLockTerritoryArgs = {
    input: LockTerritoryInput;
};

export type MutationMarkVisitAsIncompleteArgs = {
    input: MarkVisitAsIncompleteInput;
};

export type MutationMarkVisitAsMissedArgs = {
    input: MarkVisitAsMissedInput;
};

export type MutationPauseOrderArgs = {
    input: PauseOrderInput;
};

export type MutationPromoteVisitRequestArgs = {
    input: PromoteVisitRequestInput;
};

export type MutationRemoveAssociationsFromOrderArgs = {
    input: OrderAssociationInput;
};

export type MutationRemoveZipCodesFromTerritoryArgs = {
    input: RemoveZipCodesFromTerritoryInput;
};

export type MutationResend2faQrcodeEmailsArgs = {
    input: ResendUserSetupEmailsInput;
};

export type MutationResendClinicianSetupEmailsArgs = {
    input: ResendClinicianSetupEmailsInput;
};

export type MutationResendUserPasswordResetEmailsArgs = {
    input: ResendUserSetupEmailsInput;
};

export type MutationScheduleUnscheduledVisitArgs = {
    input: ScheduleUnscheduledVisitInput;
};

export type MutationSendClinicianSupportMessageArgs = {
    input: SendClinicianSupportMessageInput;
};

export type MutationSendMessageToPatientFromAssignedClinicianArgs = {
    input: SendMessageToPatientFromAssignedClinicianInput;
};

export type MutationSendPatientSupportMessageArgs = {
    input: SendPatientSupportMessageInput;
};

export type MutationSetPatientCommsPreferencesArgs = {
    input: SetPatientCommsPreferencesInput;
};

export type MutationSetPatientTimeslotPreferencesArgs = {
    input: SetPatientTimeslotPreferencesInput;
};

export type MutationStartClinicianSupportCallArgs = {
    input: StartClinicianSupportCallInput;
};

export type MutationStartPatientSupportCallArgs = {
    input: StartPatientSupportCallInput;
};

export type MutationSyncAllPatientResourcesArgs = {
    input: SyncAllPatientResourcesInput;
};

export type MutationTriggerClinicianWebhookArgs = {
    clinicianId: Scalars['UUID']['input'];
};

export type MutationTriggerEpisodeOfCareWebhookArgs = {
    episodeId: Scalars['UUID']['input'];
};

export type MutationTriggerPatientWebhookArgs = {
    patientId: Scalars['UUID']['input'];
};

export type MutationTriggerVisitRequestWebhookArgs = {
    visitRequestId: Scalars['UUID']['input'];
};

export type MutationTriggerVisitWebhookArgs = {
    visitId: Scalars['UUID']['input'];
};

export type MutationUnarchiveTerritoryArgs = {
    input: UnarchiveTerritoryInput;
};

export type MutationUncancelVisitRequestArgs = {
    visitRequestId: Scalars['UUID']['input'];
};

export type MutationUnlockTerritoryArgs = {
    input: UnlockTerritoryInput;
};

export type MutationUnpauseOrderArgs = {
    input: PauseOrderInput;
};

export type MutationUpdateVisitRequestAppointmentClinicianAssignmentArgs = {
    input: UpdateVisitRequestAppointmentClinicianAssignmentInput;
};

export type MutationUpdateVisitRequestClinicianAppointmentServicesArgs = {
    input: UpdateVisitRequestClinicianAppointmentServicesInput;
};

export type MutationUpdateVisitRequestTentativeDateArgs = {
    input: UpdateVisitRequestTentativeDateInput;
};

export type OptionValue = {
    __typename?: 'OptionValue';
    createdAt: Scalars['DateTime']['output'];
    externalIds: ExternalId[];
    id: Scalars['UUID']['output'];
    name: Scalars['String']['output'];
    organization: Organization;
    sortOrder: Scalars['Int']['output'];
    updatedAt: Scalars['DateTime']['output'];
    valueSetType: OptionValueSetType;
};

export type OptionValueFilter = {
    AND?: InputMaybe<OptionValueFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<OptionValueFilter>;
    OR?: InputMaybe<OptionValueFilter>;
    externalIds?: InputMaybe<ExternalIdFilter>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    name?: InputMaybe<StrFilterLookup>;
    organization?: InputMaybe<OrganizationFilter>;
    valueSetType?: InputMaybe<OptionValueSetTypeBaseFilterLookup>;
};

export type OptionValueOrdering = {
    createdAt?: InputMaybe<Ordering>;
    name?: InputMaybe<Ordering>;
    organization?: InputMaybe<OrganizationOrdering>;
    sortOrder?: InputMaybe<Ordering>;
    updatedAt?: InputMaybe<Ordering>;
};

export type OptionValueSet = {
    __typename?: 'OptionValueSet';
    type: OptionValueSetType;
    values: OptionValue[];
};

export type OptionValueSetValuesArgs = {
    filters?: InputMaybe<OptionValueFilter>;
    ordering?: InputMaybe<OptionValueOrdering>;
};

export enum OptionValueSetType {
    APPOINTMENT_CANCELLATION_REASON = 'APPOINTMENT_CANCELLATION_REASON',
}

export type OptionValueSetTypeBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<OptionValueSetType>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<OptionValueSetType[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OptionalDateWindowInput = {
    endDate?: InputMaybe<Scalars['Date']['input']>;
    startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type OptionalTimeWindow = {
    __typename?: 'OptionalTimeWindow';
    asDateWindow: Maybe<DateFulfillmentWindow>;
    endDatetime: Maybe<Scalars['DateTime']['output']>;
    startDatetime: Maybe<Scalars['DateTime']['output']>;
};

export type OptionalTimeWindowInput = {
    endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Order = {
    __typename?: 'Order';
    activeOccurrences: VisitVisitRequest[];
    adminChangelogLink: Maybe<Scalars['String']['output']>;
    allVisitRequests: VisitRequestPaginatedList;
    allVisits: VisitPaginatedList;
    assignedClinicians: Clinician[];
    associatedVisitRequests: VisitRequestPaginatedList;
    associatedVisits: VisitPaginatedList;
    compatibleVisitRequestsForAssociation: Maybe<VisitRequest[]>;
    compatibleVisitsForAssociation: Maybe<Visit[]>;
    createdAt: Scalars['DateTime']['output'];
    discipline: Maybe<Discipline>;
    discontinuedAt: Maybe<Scalars['DateTime']['output']>;
    episode: Maybe<EpisodeOfCare>;
    externalEpisodeId: Maybe<Scalars['String']['output']>;
    externalId: Maybe<Scalars['String']['output']>;
    externalIds: ExternalId[];
    externalLink: Maybe<Scalars['String']['output']>;
    frequency: Maybe<OrderFrequencyConfig>;
    fulfillmentWindow: DateFulfillmentWindow;
    generatedVisitRequests: VisitRequestPaginatedList;
    id: Scalars['UUID']['output'];
    inactiveOccurrences: VisitVisitRequest[];
    isActive: Scalars['Boolean']['output'];
    isComplete: Scalars['Boolean']['output'];
    isDiscontinued: Scalars['Boolean']['output'];
    isExpired: Scalars['Boolean']['output'];
    isPaused: Scalars['Boolean']['output'];
    maxActiveOccurrences: Scalars['Int']['output'];
    minActiveOccurrences: Scalars['Int']['output'];
    numActiveOccurrences: Scalars['Int']['output'];
    numCompleteOccurrences: Scalars['Int']['output'];
    numInactiveOccurrences: Scalars['Int']['output'];
    occurrences: VisitVisitRequest[];
    orderNotes: Scalars['String']['output'];
    orderType: OrderType;
    orderWarnings: OrderWarning[];
    organization: Organization;
    patient: Patient;
    prn: Maybe<OrderPrnConfig>;
    remainingAvailableVisitIntervals: Maybe<DateWindow[]>;
    syncStatus: Maybe<SyncStatus>;
    timezone: Maybe<Scalars['Timezone']['output']>;
    updatedAt: Scalars['DateTime']['output'];
    visitIntervals: Maybe<DateWindow[]>;
    warnings: OrderWarningType[];
};

export type OrderActiveOccurrencesArgs = {
    filters?: InputMaybe<OrderOccurrenceFilter>;
    ordering?: InputMaybe<OrderOccurrenceOrdering>;
};

export type OrderAllVisitRequestsArgs = {
    filters?: InputMaybe<VisitRequestFilter>;
    ordering?: InputMaybe<VisitRequestOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type OrderAllVisitsArgs = {
    filters?: InputMaybe<VisitFilter>;
    ordering?: InputMaybe<VisitOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type OrderAssociatedVisitRequestsArgs = {
    filters?: InputMaybe<VisitRequestFilter>;
    ordering?: InputMaybe<VisitRequestOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type OrderAssociatedVisitsArgs = {
    filters?: InputMaybe<VisitFilter>;
    ordering?: InputMaybe<VisitOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type OrderCompatibleVisitRequestsForAssociationArgs = {
    filters?: InputMaybe<VisitRequestFilter>;
};

export type OrderCompatibleVisitsForAssociationArgs = {
    filters?: InputMaybe<VisitFilter>;
};

export type OrderGeneratedVisitRequestsArgs = {
    filters?: InputMaybe<VisitRequestFilter>;
    ordering?: InputMaybe<VisitRequestOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type OrderInactiveOccurrencesArgs = {
    filters?: InputMaybe<OrderOccurrenceFilter>;
    ordering?: InputMaybe<OrderOccurrenceOrdering>;
};

export type OrderOccurrencesArgs = {
    filters?: InputMaybe<OrderOccurrenceFilter>;
    ordering?: InputMaybe<OrderOccurrenceOrdering>;
};

export type OrderAddAssociationsResult = {
    __typename?: 'OrderAddAssociationsResult';
    associatedVisitRequests: VisitRequest[];
    associatedVisits: Visit[];
    order: Order;
};

export type OrderAssociationInput = {
    orderId: Scalars['UUID']['input'];
    visitIds: Scalars['UUID']['input'][];
    visitRequestIds: Scalars['UUID']['input'][];
};

export type OrderFilter = {
    AND?: InputMaybe<OrderFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<OrderFilter>;
    OR?: InputMaybe<OrderFilter>;
    activeVisitRequests?: InputMaybe<VisitRequestFilter>;
    activeVisits?: InputMaybe<VisitFilter>;
    assignedClinicians?: InputMaybe<ClinicianFilter>;
    associatedVisitRequests?: InputMaybe<VisitRequestFilter>;
    associatedVisits?: InputMaybe<VisitFilter>;
    discipline?: InputMaybe<DisciplineFilter>;
    discontinuedAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
    episode?: InputMaybe<EpisodeOfCareFilter>;
    exceedsMaxActiveOccurrences?: InputMaybe<BoolBaseFilterLookup>;
    exceedsMinActiveOccurrences?: InputMaybe<BoolBaseFilterLookup>;
    externalEpisodeId?: InputMaybe<StrBaseFilterLookup>;
    externalId?: InputMaybe<StrBaseFilterLookup>;
    externalIds?: InputMaybe<ExternalIdFilter>;
    frequencyIntervalCount?: InputMaybe<IntComparisonFilterLookup>;
    frequencyIntervalUnit?: InputMaybe<RecurrenceUnitBaseFilterLookup>;
    frequencyNumVisitsPerInterval?: InputMaybe<IntComparisonFilterLookup>;
    fulfillmentWindow?: InputMaybe<OptionalDateWindowInput>;
    fulfillmentWindowEndDate?: InputMaybe<DateDateFilterLookup>;
    fulfillmentWindowStartDate?: InputMaybe<DateDateFilterLookup>;
    generatedVisitRequests?: InputMaybe<VisitRequestFilter>;
    hasEpisode?: InputMaybe<BoolBaseFilterLookup>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    isActive?: InputMaybe<BoolBaseFilterLookup>;
    isComplete?: InputMaybe<BoolBaseFilterLookup>;
    isDiscontinued?: InputMaybe<BoolBaseFilterLookup>;
    isDiscontinuedWithIncompleteOccurrences?: InputMaybe<BoolBaseFilterLookup>;
    isExpired?: InputMaybe<BoolBaseFilterLookup>;
    isFrequency?: InputMaybe<BoolBaseFilterLookup>;
    isIncompleteWithExpiredFulfillmentWindow?: InputMaybe<BoolBaseFilterLookup>;
    isPaused?: InputMaybe<BoolBaseFilterLookup>;
    isPrn?: InputMaybe<BoolBaseFilterLookup>;
    maxActiveOccurrences?: InputMaybe<IntComparisonFilterLookup>;
    minActiveOccurrences?: InputMaybe<IntComparisonFilterLookup>;
    needsAttention?: InputMaybe<BoolBaseFilterLookup>;
    numActiveOccurrences?: InputMaybe<IntComparisonFilterLookup>;
    orderType?: InputMaybe<OrderTypeBaseFilterLookup>;
    organization?: InputMaybe<OrganizationFilter>;
    patient?: InputMaybe<PatientFilter>;
    prnAuthorizedVisitCount?: InputMaybe<IntComparisonFilterLookup>;
    syncStatus?: InputMaybe<SyncStatusFilter>;
    territories?: InputMaybe<TerritoryFilter>;
};

export type OrderFrequencyConfig = {
    __typename?: 'OrderFrequencyConfig';
    intervalCount: Scalars['Int']['output'];
    intervalUnit: RecurrenceUnit;
    numVisitsPerInterval: Scalars['Int']['output'];
};

export type OrderOccurrenceFilter = {
    visit?: InputMaybe<VisitFilter>;
    visitRequest?: InputMaybe<VisitRequestFilter>;
};

export type OrderOccurrenceOrdering = {
    visit?: InputMaybe<VisitOrdering>;
    visitRequest?: InputMaybe<VisitRequestOrdering>;
};

export type OrderOrdering = {
    createdAt?: InputMaybe<Ordering>;
    discipline?: InputMaybe<DisciplineOrdering>;
    episode?: InputMaybe<EpisodeOfCareOrdering>;
    fulfillmentWindowEndDate?: InputMaybe<Ordering>;
    fulfillmentWindowStartDate?: InputMaybe<Ordering>;
    patient?: InputMaybe<PatientOrdering>;
    updatedAt?: InputMaybe<Ordering>;
};

export type OrderPrnConfig = {
    __typename?: 'OrderPRNConfig';
    authorizedVisitCount: Scalars['Int']['output'];
};

export type OrderPaginatedList = {
    __typename?: 'OrderPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: Order[];
    totalCount: Scalars['Int']['output'];
};

export type OrderRemoveAssociationsResult = {
    __typename?: 'OrderRemoveAssociationsResult';
    disassociatedVisitRequests: VisitRequest[];
    disassociatedVisits: Visit[];
    order: Order;
};

export enum OrderType {
    FREQUENCY = 'FREQUENCY',
    PRN = 'PRN',
}

export type OrderTypeBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<OrderType>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<OrderType[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderWarning = {
    __typename?: 'OrderWarning';
    message: Scalars['String']['output'];
    type: OrderWarningType;
};

export enum OrderWarningType {
    DISCONTINUED_WITH_INCOMPLETE_OCCURRENCES = 'DISCONTINUED_WITH_INCOMPLETE_OCCURRENCES',
    EXCEEDS_MAX_ACTIVE_OCCURRENCES = 'EXCEEDS_MAX_ACTIVE_OCCURRENCES',
    EXCEEDS_MIN_ACTIVE_OCCURRENCES = 'EXCEEDS_MIN_ACTIVE_OCCURRENCES',
    HAS_ACTIVE_IN_REVIEW_VISITS = 'HAS_ACTIVE_IN_REVIEW_VISITS',
    INCOMPLETE_WITH_EXPIRED_FULFILLMENT_WINDOW = 'INCOMPLETE_WITH_EXPIRED_FULFILLMENT_WINDOW',
}

export enum Ordering {
    ASC = 'ASC',
    ASC_NULLS_FIRST = 'ASC_NULLS_FIRST',
    ASC_NULLS_LAST = 'ASC_NULLS_LAST',
    DESC = 'DESC',
    DESC_NULLS_FIRST = 'DESC_NULLS_FIRST',
    DESC_NULLS_LAST = 'DESC_NULLS_LAST',
}

export type Organization = {
    __typename?: 'Organization';
    adminChangelogLink: Maybe<Scalars['String']['output']>;
    arriveByShiftEnd: Scalars['Boolean']['output'];
    assignableQualifications: Maybe<QualificationPaginatedList>;
    clinicianExternalIdRegex: Maybe<Scalars['String']['output']>;
    clinicianTeams: Maybe<ClinicianTeamPaginatedList>;
    dashboardVariation: Maybe<DashboardVariation>;
    departAtShiftStart: Scalars['Boolean']['output'];
    hasSSOEnabled: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    integrations: Maybe<Scalars['JSON']['output']>;
    logoUrl: Scalars['String']['output'];
    medicareWeekDays: DayOfWeek[];
    medicareWeekEndDay: DayOfWeek;
    medicareWeekStartDay: DayOfWeek;
    name: Scalars['String']['output'];
    patients: Maybe<PatientPaginatedList>;
    selfServeClinicianRoles: UserRole[];
    syncedResources: SyncableResourceType[];
    themeColor: Scalars['String']['output'];
    timeslotAlignmentMinutes: Scalars['Int']['output'];
    users: Maybe<UserPaginatedList>;
    viewableQualifications: Maybe<QualificationPaginatedList>;
    visits: Maybe<VisitPaginatedList>;
    writableQualifications: Maybe<QualificationPaginatedList>;
};

export type OrganizationAssignableQualificationsArgs = {
    filters?: InputMaybe<QualificationFilter>;
    ordering?: InputMaybe<QualificationOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type OrganizationClinicianTeamsArgs = {
    filters?: InputMaybe<ClinicianTeamFilter>;
    ordering?: InputMaybe<ClinicianTeamOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type OrganizationPatientsArgs = {
    filters?: InputMaybe<PatientFilter>;
    ordering?: InputMaybe<PatientOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type OrganizationUsersArgs = {
    filters?: InputMaybe<UserFilter>;
    ordering?: InputMaybe<UserOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type OrganizationViewableQualificationsArgs = {
    filters?: InputMaybe<QualificationFilter>;
    ordering?: InputMaybe<QualificationOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type OrganizationVisitsArgs = {
    filters?: InputMaybe<VisitFilter>;
    ordering?: InputMaybe<VisitOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type OrganizationWritableQualificationsArgs = {
    filters?: InputMaybe<QualificationFilter>;
    ordering?: InputMaybe<QualificationOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type OrganizationFilter = {
    AND?: InputMaybe<OrganizationFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<OrganizationFilter>;
    OR?: InputMaybe<OrganizationFilter>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    metadata?: InputMaybe<JsonjsonFilterLookup>;
    name?: InputMaybe<StrFilterLookup>;
};

export type OrganizationOrdering = {
    createdAt?: InputMaybe<Ordering>;
    name?: InputMaybe<Ordering>;
};

export type OrganizationPaginatedList = {
    __typename?: 'OrganizationPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: Organization[];
    totalCount: Scalars['Int']['output'];
};

export type PaginationInput = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset: Scalars['Int']['input'];
};

export type Patient = {
    __typename?: 'Patient';
    addresses: Address[];
    adminChangelogLink: Maybe<Scalars['String']['output']>;
    careTeams: CareTeam[];
    communicationPreferences: PatientCommunicationPreferences;
    communications: PatientCommunications;
    createdAt: Scalars['DateTime']['output'];
    currentEpisode: Maybe<EpisodeOfCare>;
    dateOfBirth: Scalars['Date']['output'];
    defaultEpisode: Maybe<EpisodeOfCare>;
    documents: Document[];
    email: Maybe<Scalars['Email']['output']>;
    episodeNotes: Maybe<Scalars['String']['output']>;
    episodes: Maybe<EpisodeOfCarePaginatedList>;
    externalId: Scalars['String']['output'];
    externalIds: ExternalId[];
    externalLink: Maybe<Scalars['String']['output']>;
    firstName: Scalars['String']['output'];
    fullName: Scalars['String']['output'];
    id: Scalars['UUID']['output'];
    isPhoneNumberLandline: Scalars['Boolean']['output'];
    lastName: Scalars['String']['output'];
    latestEpisode: Maybe<EpisodeOfCare>;
    linkToPatientVisits: Maybe<Scalars['String']['output']>;
    metadata: Maybe<Scalars['JSON']['output']>;
    notes: Maybe<Scalars['String']['output']>;
    notesForClinician: Maybe<Scalars['String']['output']>;
    orders: Maybe<OrderPaginatedList>;
    organization: Organization;
    payers: Payer[];
    permissions: PatientPermissions;
    phoneNumber: Maybe<Scalars['PhoneE164']['output']>;
    preferredClinicianSex: Maybe<Sex>;
    preferredLanguage: Language;
    preferredTimeslots: DayOfWeekTimeslot[];
    sex: Sex;
    syncStatus: Maybe<SyncStatus>;
    timezone: Maybe<Scalars['Timezone']['output']>;
    updatedAt: Scalars['DateTime']['output'];
    visitOrders: Maybe<VisitOrderPaginatedList>;
    visitRequests: Maybe<VisitRequestPaginatedList>;
    visits: Maybe<VisitPaginatedList>;
};

export type PatientEpisodesArgs = {
    filters?: InputMaybe<EpisodeOfCareFilter>;
    ordering?: InputMaybe<EpisodeOfCareOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type PatientLinkToPatientVisitsArgs = {
    includeQueryParams: Scalars['Boolean']['input'];
};

export type PatientOrdersArgs = {
    filters?: InputMaybe<OrderFilter>;
    ordering?: InputMaybe<OrderOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type PatientPreferredTimeslotsArgs = {
    filters?: InputMaybe<DayOfWeekTimeslotFilter>;
    ordering?: InputMaybe<DayOfWeekTimeslotOrdering>;
};

export type PatientVisitOrdersArgs = {
    filters?: InputMaybe<VisitOrderFilter>;
    ordering?: InputMaybe<VisitOrderOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type PatientVisitRequestsArgs = {
    filters?: InputMaybe<VisitRequestFilter>;
    ordering?: InputMaybe<VisitRequestOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type PatientVisitsArgs = {
    filters?: InputMaybe<VisitFilter>;
    ordering?: InputMaybe<VisitOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type PatientCommunicationPreferences = {
    __typename?: 'PatientCommunicationPreferences';
    allowsAutomatedCalls: Scalars['Boolean']['output'];
    allowsAutomatedEmails: Scalars['Boolean']['output'];
    allowsAutomatedSms: Scalars['Boolean']['output'];
    allowsClinicianCalls: Scalars['Boolean']['output'];
    allowsClinicianSms: Scalars['Boolean']['output'];
    id: Scalars['UUID']['output'];
};

export type PatientCommunications = {
    __typename?: 'PatientCommunications';
    id: Scalars['UUID']['output'];
    patientSystemCommunications: Maybe<Communication[]>;
};

export type PatientCommunicationsPatientSystemCommunicationsArgs = {
    filters?: InputMaybe<CommunicationFilter>;
    ordering?: InputMaybe<CommunicationOrdering>;
};

export type PatientFilter = {
    AND?: InputMaybe<PatientFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<PatientFilter>;
    OR?: InputMaybe<PatientFilter>;
    careTeams?: InputMaybe<CareTeamFilter>;
    episodes?: InputMaybe<EpisodeOfCareFilter>;
    externalId?: InputMaybe<StrBaseFilterLookup>;
    externalIds?: InputMaybe<ExternalIdFilter>;
    firstName?: InputMaybe<StrFilterLookup>;
    fullName?: InputMaybe<StrFilterLookup>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    lastName?: InputMaybe<StrFilterLookup>;
    metadata?: InputMaybe<JsonjsonFilterLookup>;
    notes?: InputMaybe<StrFilterLookup>;
    notesForClinician?: InputMaybe<StrFilterLookup>;
    numEpisodes?: InputMaybe<IntComparisonFilterLookup>;
    numPayers?: InputMaybe<IntComparisonFilterLookup>;
    orders?: InputMaybe<OrderFilter>;
    organization?: InputMaybe<OrganizationFilter>;
    payers?: InputMaybe<PayerFilter>;
    phoneNumber?: InputMaybe<StrBaseFilterLookup>;
    searchTerm?: InputMaybe<Scalars['String']['input']>;
    serviceAreas?: InputMaybe<ServiceAreaFilter>;
    syncStatus?: InputMaybe<SyncStatusFilter>;
    visitOrders?: InputMaybe<VisitOrderFilter>;
    visitRequests?: InputMaybe<VisitRequestFilter>;
    visits?: InputMaybe<VisitFilter>;
};

export type PatientOrdering = {
    createdAt?: InputMaybe<Ordering>;
    dateOfBirth?: InputMaybe<Ordering>;
    episodes?: InputMaybe<EpisodeOfCareOrdering>;
    firstName?: InputMaybe<Ordering>;
    fullName?: InputMaybe<Ordering>;
    lastName?: InputMaybe<Ordering>;
    notesForClinician?: InputMaybe<Ordering>;
    organization?: InputMaybe<OrganizationOrdering>;
    searchRanking?: InputMaybe<Ordering>;
    updatedAt?: InputMaybe<Ordering>;
};

export type PatientPaginatedList = {
    __typename?: 'PatientPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: Patient[];
    totalCount: Scalars['Int']['output'];
};

export type PatientPermissions = {
    __typename?: 'PatientPermissions';
    callPatient: Scalars['Boolean']['output'];
    edit: Scalars['Boolean']['output'];
    editAddress: Scalars['Boolean']['output'];
    editCommunicationsPreferences: Scalars['Boolean']['output'];
    editDetails: Scalars['Boolean']['output'];
    editDocuments: Scalars['Boolean']['output'];
    editInternalNotes: Scalars['Boolean']['output'];
    /** @deprecated With the introduction of patient notes_for_clinician, 'notes' are now 'internal_notes' for clarity. Use edit_internal_notes instead.  */
    editNotes: Scalars['Boolean']['output'];
    editNotesForClinician: Scalars['Boolean']['output'];
    editPayers: Scalars['Boolean']['output'];
    id: Scalars['UUID']['output'];
    sendCommunications: Scalars['Boolean']['output'];
    toggleCommunications: Scalars['Boolean']['output'];
    viewCommunications: Scalars['Boolean']['output'];
    viewDetails: Scalars['Boolean']['output'];
    viewDocuments: Scalars['Boolean']['output'];
    viewInternalNotes: Scalars['Boolean']['output'];
    viewMetadata: Scalars['Boolean']['output'];
    /** @deprecated With the introduction of patient notes_for_clinician, 'notes' are now 'internal_notes' for clarity. Use view_internal_notes instead.  */
    viewNotes: Scalars['Boolean']['output'];
    viewNotesForClinician: Scalars['Boolean']['output'];
};

export enum PatientTimeslotDayOfWeek {
    FRI = 'FRI',
    MON = 'MON',
    SAT = 'SAT',
    SUN = 'SUN',
    THU = 'THU',
    TUE = 'TUE',
    WED = 'WED',
}

export type PauseOrderInput = {
    orderId: Scalars['UUID']['input'];
};

export type Payer = {
    __typename?: 'Payer';
    description: Scalars['String']['output'];
    externalIds: ExternalId[];
    id: Scalars['UUID']['output'];
    name: Scalars['String']['output'];
    organization: Organization;
};

export type PayerFilter = {
    AND?: InputMaybe<PayerFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<PayerFilter>;
    OR?: InputMaybe<PayerFilter>;
    externalIds?: InputMaybe<ExternalIdFilter>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    name?: InputMaybe<StrFilterLookup>;
    organization?: InputMaybe<OrganizationFilter>;
};

export type PayerOrdering = {
    name?: InputMaybe<Ordering>;
    organization?: InputMaybe<OrganizationOrdering>;
};

export type PayerPaginatedList = {
    __typename?: 'PayerPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: Payer[];
    totalCount: Scalars['Int']['output'];
};

export type PhoneNumber = {
    __typename?: 'PhoneNumber';
    phoneNumber: Scalars['String']['output'];
};

export type PotentialAppointmentAssignment = {
    __typename?: 'PotentialAppointmentAssignment';
    clinician: Maybe<Clinician>;
    clinicianAppointmentId: Scalars['UUID']['output'];
};

export type PrefillAddress = {
    __typename?: 'PrefillAddress';
    city: Maybe<Scalars['String']['output']>;
    line1: Maybe<Scalars['String']['output']>;
    line2: Maybe<Scalars['String']['output']>;
    state: Maybe<Scalars['String']['output']>;
    zipCode: Maybe<Scalars['String']['output']>;
};

export type PrefillData = {
    __typename?: 'PrefillData';
    patientPrefillData: PrefillPatientData;
    visitPrefillData: PrefillVisitData;
};

export type PrefillPatientData = {
    __typename?: 'PrefillPatientData';
    address: Maybe<PrefillAddress>;
    dateOfBirth: Maybe<Scalars['Date']['output']>;
    email: Maybe<Scalars['String']['output']>;
    firstName: Maybe<Scalars['String']['output']>;
    lastName: Maybe<Scalars['String']['output']>;
    metadata: Maybe<Scalars['JSON']['output']>;
    phone: Maybe<Scalars['String']['output']>;
    preferredLanguage: Maybe<Language>;
    sex: Maybe<Sex>;
};

export type PrefillVisitData = {
    __typename?: 'PrefillVisitData';
    serviceArea: Maybe<ServiceArea>;
    serviceBundle: Maybe<ServiceBundle>;
};

export type PromoteVisitRequestBulkResponse = {
    __typename?: 'PromoteVisitRequestBulkResponse';
    errorCount: Scalars['Int']['output'];
    results: VisitRequestBulkMutationResult[];
    success: Scalars['Boolean']['output'];
    successCount: Scalars['Int']['output'];
    totalCount: Scalars['Int']['output'];
};

export type PromoteVisitRequestInput = {
    visitRequestId: Scalars['UUID']['input'];
};

export type Qualification = {
    __typename?: 'Qualification';
    canRead: Scalars['Boolean']['output'];
    canWrite: Scalars['Boolean']['output'];
    description: Scalars['String']['output'];
    id: Scalars['UUID']['output'];
    name: Scalars['String']['output'];
    organization: Organization;
};

export type QualificationAggregationSetDeprecated = {
    __typename?: 'QualificationAggregationSetDeprecated';
    items: Qualification[];
    operator: AggregationOperator;
};

export type QualificationFilter = {
    AND?: InputMaybe<QualificationFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<QualificationFilter>;
    OR?: InputMaybe<QualificationFilter>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    name?: InputMaybe<StrFilterLookup>;
    organization?: InputMaybe<OrganizationFilter>;
};

export type QualificationOrdering = {
    name?: InputMaybe<Ordering>;
    organization?: InputMaybe<OrganizationOrdering>;
};

export type QualificationPaginatedList = {
    __typename?: 'QualificationPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: Qualification[];
    totalCount: Scalars['Int']['output'];
};

export type Query = {
    __typename?: 'Query';
    address: Maybe<Address>;
    addressLookup: Maybe<Address>;
    appointmentClinicianOptions: Clinician[];
    appointmentServiceOptions: Service[];
    careTeam: Maybe<CareTeam>;
    careTeams: Maybe<CareTeamPaginatedList>;
    clinician: Maybe<Clinician>;
    clinicianAppointment: Maybe<ClinicianAppointment>;
    clinicianAppointments: Maybe<ClinicianAppointmentPaginatedList>;
    clinicianSchedules: Maybe<ClinicianSchedules>;
    clinicianTeam: Maybe<ClinicianTeam>;
    clinicianTeams: Maybe<ClinicianTeamPaginatedList>;
    clinicians: Maybe<ClinicianPaginatedList>;
    confirmedAvailability: Maybe<Availability[]>;
    currentClinician: Maybe<Clinician>;
    currentOrganization: Maybe<Organization>;
    currentUser: Maybe<User>;
    decisionSupport: DecisionSupportQuery;
    decryptPrefillData: PrefillData;
    discipline: Maybe<Discipline>;
    disciplines: Maybe<DisciplinePaginatedList>;
    eligibilityForServiceBundleBeta: Maybe<Eligibility>;
    encryptPrefillData: Scalars['String']['output'];
    episodeOfCare: Maybe<EpisodeOfCare>;
    episodesOfCare: Maybe<EpisodeOfCarePaginatedList>;
    featureFlags: FeatureFlag[];
    findClinician: Maybe<Clinician>;
    findClinicianAppointment: Maybe<ClinicianAppointment>;
    findDiscipline: Maybe<Discipline>;
    findEpisodeOfCare: Maybe<EpisodeOfCare>;
    findOrder: Maybe<Order>;
    findPatient: Maybe<Patient>;
    findPayer: Maybe<Payer>;
    findService: Maybe<Service>;
    findServiceArea: Maybe<ServiceArea>;
    findTripTask: Maybe<TripTask>;
    findVisit: Maybe<Visit>;
    findVisitRequest: Maybe<VisitRequest>;
    hello: Scalars['String']['output'];
    helloError: Maybe<Scalars['String']['output']>;
    helloProtected: Maybe<Scalars['String']['output']>;
    helloRestricted: Scalars['String']['output'];
    helloRestrictedWithFeatureFlag: Scalars['String']['output'];
    helloWithFeatureFlag: Maybe<Scalars['String']['output']>;
    licenses: License[];
    lookupDiscipline: Maybe<Discipline>;
    optimizedRoutes: Maybe<RouteOptimizerResult>;
    optionValue: Maybe<OptionValue>;
    optionValueSet: Maybe<OptionValueSet>;
    optionValues: Maybe<OptionValue[]>;
    order: Maybe<Order>;
    orders: Maybe<OrderPaginatedList>;
    organization: Maybe<Organization>;
    organizations: Maybe<OrganizationPaginatedList>;
    patient: Maybe<Patient>;
    patients: Maybe<PatientPaginatedList>;
    payer: Maybe<Payer>;
    payers: Maybe<PayerPaginatedList>;
    polylineRoute: Coordinates[];
    polylineRoutes: Coordinates[][];
    qualification: Maybe<Qualification>;
    reservation: Maybe<Reservation>;
    scheduleChangeRequests: ScheduleChangeRequests;
    service: Maybe<Service>;
    serviceArea: Maybe<ServiceArea>;
    serviceAreas: Maybe<ServiceAreaPaginatedList>;
    serviceBundle: Maybe<ServiceBundle>;
    serviceBundles: Maybe<ServiceBundle[]>;
    services: Maybe<ServicePaginatedList>;
    shiftBlockRecurrence: Maybe<ShiftBlockRecurrence>;
    shiftBlockRecurrences: Maybe<ShiftBlockRecurrencePaginatedList>;
    shiftRecurrence: Maybe<ShiftRecurrence>;
    shiftRecurrences: Maybe<ShiftRecurrencePaginatedList>;
    territories: Maybe<TerritoryPaginatedList>;
    territory: Maybe<Territory>;
    tripTask: Maybe<TripTask>;
    tripTasks: Maybe<TripTaskPaginatedList>;
    unconfirmedAvailability: Maybe<Availability>;
    user: Maybe<User>;
    users: Maybe<UserPaginatedList>;
    viewableQualifications: Maybe<QualificationPaginatedList>;
    viewableVisitOutcomes: Maybe<VisitOutcome[]>;
    viewableVisitStates: Maybe<VisitState[]>;
    visit: Maybe<Visit>;
    visitOrder: Maybe<VisitOrder>;
    visitOrders: Maybe<VisitOrderPaginatedList>;
    visitRequest: Maybe<VisitRequest>;
    visitRequests: Maybe<VisitRequestPaginatedList>;
    visits: Maybe<VisitPaginatedList>;
    writableQualifications: Maybe<QualificationPaginatedList>;
};

export type QueryAddressArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryAddressLookupArgs = {
    address: AddressInput;
};

export type QueryCareTeamArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryCareTeamsArgs = {
    filters?: InputMaybe<CareTeamFilter>;
    ordering?: InputMaybe<CareTeamOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryClinicianArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryClinicianAppointmentArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryClinicianAppointmentsArgs = {
    filters?: InputMaybe<ClinicianAppointmentFilter>;
    ordering?: InputMaybe<ClinicianAppointmentOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryClinicianSchedulesArgs = {
    endDate?: InputMaybe<Scalars['Date']['input']>;
    endDatetime: Scalars['DateTime']['input'];
    filters?: InputMaybe<ClinicianSchedulesFilters>;
    startDate?: InputMaybe<Scalars['Date']['input']>;
    startDatetime: Scalars['DateTime']['input'];
};

export type QueryClinicianTeamArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryClinicianTeamsArgs = {
    filters?: InputMaybe<ClinicianTeamFilter>;
    ordering?: InputMaybe<ClinicianTeamOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryCliniciansArgs = {
    filters?: InputMaybe<ClinicianFilter>;
    ordering?: InputMaybe<ClinicianOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryConfirmedAvailabilityArgs = {
    filter: AvailabilityFilter;
    input: ConfirmedAvailabilityInput;
};

export type QueryDecryptPrefillDataArgs = {
    encryptedData: Scalars['String']['input'];
};

export type QueryDisciplineArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryDisciplinesArgs = {
    filters?: InputMaybe<DisciplineFilter>;
    ordering?: InputMaybe<DisciplineOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryEligibilityForServiceBundleBetaArgs = {
    filters?: InputMaybe<EligibilityFilter>;
    input: EligibilityForServiceBundleInput;
};

export type QueryEncryptPrefillDataArgs = {
    dataObj: Scalars['JSON']['input'];
};

export type QueryEpisodeOfCareArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryEpisodesOfCareArgs = {
    filters?: InputMaybe<EpisodeOfCareFilter>;
    ordering?: InputMaybe<EpisodeOfCareOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryFeatureFlagsArgs = {
    keys: Scalars['String']['input'][];
};

export type QueryFindClinicianArgs = {
    filters: ClinicianFilter;
};

export type QueryFindClinicianAppointmentArgs = {
    filters: ClinicianAppointmentFilter;
};

export type QueryFindDisciplineArgs = {
    filters: DisciplineFilter;
};

export type QueryFindEpisodeOfCareArgs = {
    filters: EpisodeOfCareFilter;
};

export type QueryFindOrderArgs = {
    filters: OrderFilter;
};

export type QueryFindPatientArgs = {
    filters: PatientFilter;
};

export type QueryFindPayerArgs = {
    filters: PayerFilter;
};

export type QueryFindServiceArgs = {
    filters: ServiceFilter;
};

export type QueryFindServiceAreaArgs = {
    filters: ServiceAreaFilter;
};

export type QueryFindTripTaskArgs = {
    filters: TripTaskFilter;
};

export type QueryFindVisitArgs = {
    filters: VisitFilter;
};

export type QueryFindVisitRequestArgs = {
    filters: VisitRequestFilter;
};

export type QueryHelloArgs = {
    tellSentry?: Scalars['Boolean']['input'];
};

export type QueryLookupDisciplineArgs = {
    code: Scalars['String']['input'];
};

export type QueryOptimizedRoutesArgs = {
    endDatetime: Scalars['DateTime']['input'];
    preserveExistingAssignments?: Scalars['Boolean']['input'];
    startDatetime: Scalars['DateTime']['input'];
    useInhouseSolver?: Scalars['Boolean']['input'];
    visitIds: Scalars['UUID']['input'][];
};

export type QueryOptionValueArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryOptionValueSetArgs = {
    type: OptionValueSetType;
};

export type QueryOptionValuesArgs = {
    filters?: InputMaybe<OptionValueFilter>;
    ordering?: InputMaybe<OptionValueOrdering>;
};

export type QueryOrderArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryOrdersArgs = {
    filters?: InputMaybe<OrderFilter>;
    ordering?: InputMaybe<OrderOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryOrganizationArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryOrganizationsArgs = {
    filters?: InputMaybe<OrganizationFilter>;
    ordering?: InputMaybe<OrganizationOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryPatientArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryPatientsArgs = {
    filters?: InputMaybe<PatientFilter>;
    ordering?: InputMaybe<PatientOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryPayerArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryPayersArgs = {
    filters?: InputMaybe<PayerFilter>;
    ordering?: InputMaybe<PayerOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryPolylineRouteArgs = {
    destinationLatLng: CoordinatesInput;
    startLatLng: CoordinatesInput;
};

export type QueryPolylineRoutesArgs = {
    startDestinationLatLngs: StartDestinationCoordinatesInput[];
};

export type QueryQualificationArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryReservationArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryServiceArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryServiceAreaArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryServiceAreasArgs = {
    filters?: InputMaybe<ServiceAreaFilter>;
    ordering?: InputMaybe<ServiceAreaOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryServiceBundleArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryServicesArgs = {
    filters?: InputMaybe<ServiceFilter>;
    ordering?: InputMaybe<ServiceOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryShiftBlockRecurrenceArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryShiftBlockRecurrencesArgs = {
    filters?: InputMaybe<ShiftBlockRecurrenceFilter>;
    ordering?: InputMaybe<ShiftBlockRecurrenceOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryShiftRecurrenceArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryShiftRecurrencesArgs = {
    filters?: InputMaybe<ShiftRecurrenceFilter>;
    ordering?: InputMaybe<ShiftRecurrenceOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryTerritoriesArgs = {
    filters?: InputMaybe<TerritoryFilter>;
    ordering?: InputMaybe<TerritoryOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryTerritoryArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryTripTaskArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryTripTasksArgs = {
    filters?: InputMaybe<TripTaskFilter>;
    ordering?: InputMaybe<TripTaskOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryUnconfirmedAvailabilityArgs = {
    filter: AvailabilityFilter;
    input: UnconfirmedAvailabilityInput;
};

export type QueryUserArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryUsersArgs = {
    filters?: InputMaybe<UserFilter>;
    ordering?: InputMaybe<UserOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryViewableQualificationsArgs = {
    filters?: InputMaybe<QualificationFilter>;
    ordering?: InputMaybe<QualificationOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryVisitArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryVisitOrderArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryVisitOrdersArgs = {
    filters?: InputMaybe<VisitOrderFilter>;
    ordering?: InputMaybe<VisitOrderOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryVisitRequestArgs = {
    id: Scalars['UUID']['input'];
};

export type QueryVisitRequestsArgs = {
    filters?: InputMaybe<VisitRequestFilter>;
    ordering?: InputMaybe<VisitRequestOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryVisitsArgs = {
    filters?: InputMaybe<VisitFilter>;
    ordering?: InputMaybe<VisitOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type QueryWritableQualificationsArgs = {
    filters?: InputMaybe<QualificationFilter>;
    ordering?: InputMaybe<QualificationOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export enum QuestionType {
    CHECKBOX = 'CHECKBOX',
    DROPDOWN = 'DROPDOWN',
    MULTILINE = 'MULTILINE',
    MULTISELECT = 'MULTISELECT',
    NUMBER = 'NUMBER',
    TEXTFIELD = 'TEXTFIELD',
}

export type RecurrenceInput = {
    excludeDatetimes: Scalars['DateTime']['input'][];
    recurrenceRule: Scalars['NonEmptyString']['input'];
};

export enum RecurrenceMutationScope {
    ALL_OCCURRENCES = 'ALL_OCCURRENCES',
    SINGLE_OCCURRENCE = 'SINGLE_OCCURRENCE',
    THIS_AND_FUTURE_OCCURRENCES = 'THIS_AND_FUTURE_OCCURRENCES',
}

export type RecurrenceRule = {
    createdAt: Scalars['DateTime']['output'];
    deletedAt: Maybe<Scalars['DateTime']['output']>;
    endDatetime: Scalars['DateTime']['output'];
    excludeDatetimes: Scalars['DateTime']['output'][];
    nextOccurrenceWindow: Maybe<TimeWindow>;
    recurrenceRule: Scalars['String']['output'];
    startDatetime: Scalars['DateTime']['output'];
    timezone: Scalars['Timezone']['output'];
    untilDatetime: Maybe<Scalars['DateTime']['output']>;
    updatedAt: Scalars['DateTime']['output'];
};

export enum RecurrenceUnit {
    DAY = 'DAY',
    EVERY_OTHER_DAY = 'EVERY_OTHER_DAY',
    EVERY_OTHER_MONTH = 'EVERY_OTHER_MONTH',
    EVERY_OTHER_WEEK = 'EVERY_OTHER_WEEK',
    MONTH = 'MONTH',
    WEEK = 'WEEK',
}

export type RecurrenceUnitBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<RecurrenceUnit>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<RecurrenceUnit[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RelatedVisitConditionInput = {
    exists: Scalars['Boolean']['input'];
    filter?: InputMaybe<VisitFilter>;
    sameEpisode?: Scalars['Boolean']['input'];
    samePatient?: Scalars['Boolean']['input'];
    timeConstraints?: InputMaybe<RelativeTimeConstraintInput[]>;
};

export type RelativeTimeConstraintInput = {
    field: VisitDatetimeField;
    gtOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
    gteOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
    ltOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
    lteOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
    relativeTo: VisitDatetimeField;
};

export type RemoveZipCodesFromTerritoryInput = {
    territoryId: Scalars['UUID']['input'];
    zipCodesToRemove: Scalars['ZipCode']['input'][];
};

export type RequestToCreateShift = RecurrenceRule & {
    __typename?: 'RequestToCreateShift';
    clinic: Maybe<ServiceArea>;
    createdAt: Scalars['DateTime']['output'];
    deletedAt: Maybe<Scalars['DateTime']['output']>;
    denialReason: Maybe<Scalars['String']['output']>;
    endAddress: Maybe<Address>;
    endDatetime: Scalars['DateTime']['output'];
    excludeDatetimes: Scalars['DateTime']['output'][];
    id: Scalars['UUID']['output'];
    mobileTerritories: Territory[];
    nextOccurrence: Maybe<TentativeShiftOccurrence>;
    nextOccurrenceWindow: Maybe<TimeWindow>;
    notes: Scalars['String']['output'];
    recurrenceRule: Scalars['String']['output'];
    requestingClinician: Clinician;
    resultingShift: Maybe<ShiftRecurrence>;
    startAddress: Maybe<Address>;
    startDatetime: Scalars['DateTime']['output'];
    state: ScheduleChangeRequestState;
    tentativeOccurrences: TentativeShiftOccurrence[];
    timezone: Scalars['Timezone']['output'];
    untilDatetime: Maybe<Scalars['DateTime']['output']>;
    updatedAt: Scalars['DateTime']['output'];
    virtualTerritories: Territory[];
};

export type RequestToCreateShiftTentativeOccurrencesArgs = {
    endDatetime: Scalars['DateTime']['input'];
    startDatetime: Scalars['DateTime']['input'];
};

export type RequestToCreateShiftBlock = RecurrenceRule & {
    __typename?: 'RequestToCreateShiftBlock';
    createdAt: Scalars['DateTime']['output'];
    deletedAt: Maybe<Scalars['DateTime']['output']>;
    denialReason: Maybe<Scalars['String']['output']>;
    endDatetime: Scalars['DateTime']['output'];
    excludeDatetimes: Scalars['DateTime']['output'][];
    id: Scalars['UUID']['output'];
    nextOccurrence: Maybe<TentativeShiftBlockOccurrence>;
    nextOccurrenceWindow: Maybe<TimeWindow>;
    notes: Scalars['String']['output'];
    overlappingClinicianAppointments: Maybe<ClinicianAppointment[]>;
    overlappingVisits: Maybe<Visit[]>;
    recurrenceRule: Scalars['String']['output'];
    requestingClinician: Clinician;
    resultingShiftBlock: Maybe<ShiftBlockRecurrence>;
    startAddress: Maybe<Address>;
    startDatetime: Scalars['DateTime']['output'];
    state: ScheduleChangeRequestState;
    tentativeOccurrences: TentativeShiftBlockOccurrence[];
    timezone: Scalars['Timezone']['output'];
    untilDatetime: Maybe<Scalars['DateTime']['output']>;
    updatedAt: Scalars['DateTime']['output'];
};

export type RequestToCreateShiftBlockTentativeOccurrencesArgs = {
    endDatetime: Scalars['DateTime']['input'];
    startDatetime: Scalars['DateTime']['input'];
};

export type RequestToCreateShiftBlockFilter = {
    AND?: InputMaybe<RequestToCreateShiftBlockFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<RequestToCreateShiftBlockFilter>;
    OR?: InputMaybe<RequestToCreateShiftBlockFilter>;
    createdAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
    deletedAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
    endDatetime?: InputMaybe<DatetimeDatetimeFilterLookup>;
    hasRecurrence?: InputMaybe<BoolBaseFilterLookup>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    mayHaveFutureOccurrences?: InputMaybe<BoolBaseFilterLookup>;
    recurrenceRule?: InputMaybe<StrFilterLookup>;
    requestingClinician?: InputMaybe<ClinicianFilter>;
    startDatetime?: InputMaybe<DatetimeDatetimeFilterLookup>;
    state?: InputMaybe<ScheduleChangeRequestStateBaseFilterLookup>;
    updatedAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
};

export type RequestToCreateShiftBlockOrdering = {
    createdAt?: InputMaybe<Ordering>;
    startDatetime?: InputMaybe<Ordering>;
};

export type RequestToCreateShiftBlockPaginatedList = {
    __typename?: 'RequestToCreateShiftBlockPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: RequestToCreateShiftBlock[];
    totalCount: Scalars['Int']['output'];
};

export type RequestToCreateShiftFilter = {
    AND?: InputMaybe<RequestToCreateShiftFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<RequestToCreateShiftFilter>;
    OR?: InputMaybe<RequestToCreateShiftFilter>;
    createdAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
    deletedAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
    endDatetime?: InputMaybe<DatetimeDatetimeFilterLookup>;
    hasRecurrence?: InputMaybe<BoolBaseFilterLookup>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    mayHaveFutureOccurrences?: InputMaybe<BoolBaseFilterLookup>;
    recurrenceRule?: InputMaybe<StrFilterLookup>;
    requestingClinician?: InputMaybe<ClinicianFilter>;
    startDatetime?: InputMaybe<DatetimeDatetimeFilterLookup>;
    state?: InputMaybe<ScheduleChangeRequestStateBaseFilterLookup>;
    updatedAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
};

export type RequestToCreateShiftOrdering = {
    createdAt?: InputMaybe<Ordering>;
    startDatetime?: InputMaybe<Ordering>;
};

export type RequestToCreateShiftPaginatedList = {
    __typename?: 'RequestToCreateShiftPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: RequestToCreateShift[];
    totalCount: Scalars['Int']['output'];
};

export type ResendClinicianSetupEmailsInput = {
    clinicianId: Scalars['UUID']['input'];
};

export type ResendUserSetupEmailsInput = {
    userId: Scalars['UUID']['input'];
};

export type Reservation = {
    __typename?: 'Reservation';
    address: Maybe<Address>;
    createdAt: Scalars['DateTime']['output'];
    expiryDatetime: Scalars['DateTime']['output'];
    externalId: Maybe<Scalars['String']['output']>;
    id: Scalars['UUID']['output'];
    isFulfilled: Scalars['Boolean']['output'];
    organization: Organization;
    startDatetime: Scalars['DateTime']['output'];
    zipCode: Maybe<Scalars['String']['output']>;
    zipcode: Maybe<Scalars['String']['output']>;
};

export type ResourceEligibility = {
    __typename?: 'ResourceEligibility';
    clinicians: Clinician[];
    eligibilityBoundResource: Maybe<ServiceBundlePositionClinicianAppointment>;
};

export type RouteOptimizerFilter = {
    AND?: InputMaybe<RouteOptimizerFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<RouteOptimizerFilter>;
    OR?: InputMaybe<RouteOptimizerFilter>;
    selectedDateWindow?: InputMaybe<DateWindowInput>;
};

export type RouteOptimizerResult = {
    __typename?: 'RouteOptimizerResult';
    numRoutedVisits: Scalars['Int']['output'];
    numUnroutedVisits: Scalars['Int']['output'];
    patientsWithOverlappingTentativeVisits: Patient[];
    routedVisits: TentativeRoutedVisit[];
    solutionTraceId: Maybe<Scalars['UUID']['output']>;
    unroutedVisits: Visit[];
};

export type ScheduleChangeRequestMutations = {
    __typename?: 'ScheduleChangeRequestMutations';
    approveRequestToCreateShiftBlock: Maybe<RequestToCreateShiftBlock>;
    cancelRequestToCreateShiftBlock: Maybe<RequestToCreateShiftBlock>;
    createRequestToCreateShiftBlock: Maybe<RequestToCreateShiftBlock>;
    denyRequestToCreateShiftBlock: Maybe<RequestToCreateShiftBlock>;
    editRequestToCreateShiftBlock: Maybe<RequestToCreateShiftBlock>;
};

export type ScheduleChangeRequestMutationsApproveRequestToCreateShiftBlockArgs = {
    input: ApproveRequestToCreateShiftBlockInput;
};

export type ScheduleChangeRequestMutationsCancelRequestToCreateShiftBlockArgs = {
    input: CancelRequestToCreateShiftBlockInput;
};

export type ScheduleChangeRequestMutationsCreateRequestToCreateShiftBlockArgs = {
    input: CreateRequestToCreateShiftBlockInput;
};

export type ScheduleChangeRequestMutationsDenyRequestToCreateShiftBlockArgs = {
    input: DenyRequestToCreateShiftBlockInput;
};

export type ScheduleChangeRequestMutationsEditRequestToCreateShiftBlockArgs = {
    input: EditRequestToCreateShiftBlockInput;
};

export enum ScheduleChangeRequestState {
    APPROVED = 'APPROVED',
    CANCELED = 'CANCELED',
    DENIED = 'DENIED',
    PENDING = 'PENDING',
}

export type ScheduleChangeRequestStateBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<ScheduleChangeRequestState>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<ScheduleChangeRequestState[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScheduleChangeRequests = {
    __typename?: 'ScheduleChangeRequests';
    requestToCreateShift: Maybe<RequestToCreateShift>;
    requestToCreateShiftBlock: Maybe<RequestToCreateShiftBlock>;
    requestsToCreateShift: Maybe<RequestToCreateShiftPaginatedList>;
    requestsToCreateShiftBlock: Maybe<RequestToCreateShiftBlockPaginatedList>;
};

export type ScheduleChangeRequestsRequestToCreateShiftArgs = {
    id: Scalars['UUID']['input'];
};

export type ScheduleChangeRequestsRequestToCreateShiftBlockArgs = {
    id: Scalars['UUID']['input'];
};

export type ScheduleChangeRequestsRequestsToCreateShiftArgs = {
    filters?: InputMaybe<RequestToCreateShiftFilter>;
    ordering?: InputMaybe<RequestToCreateShiftOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type ScheduleChangeRequestsRequestsToCreateShiftBlockArgs = {
    filters?: InputMaybe<RequestToCreateShiftBlockFilter>;
    ordering?: InputMaybe<RequestToCreateShiftBlockOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type ScheduleEvent = {
    createdAt: Scalars['DateTime']['output'];
    endDatetime: Scalars['DateTime']['output'];
    startDatetime: Scalars['DateTime']['output'];
    timezone: Scalars['Timezone']['output'];
};

export type ScheduleUnscheduledVisitInput = {
    assignedCliniciansAndPositions: AssignedCliniciansAndPositionsInput[];
    startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    visitId: Scalars['UUID']['input'];
};

export type SelfSchedulableVisitsFilter = {
    routeOptimizer?: InputMaybe<RouteOptimizerFilter>;
    visit?: InputMaybe<VisitFilter>;
};

export type SendClinicianSupportMessageInput = {
    clinicianId: Scalars['UUID']['input'];
    messageBody: Scalars['String']['input'];
};

export type SendMessageToPatientFromAssignedClinicianInput = {
    messageBody: Scalars['String']['input'];
    visitId: Scalars['UUID']['input'];
};

export type SendPatientSupportMessageInput = {
    messageBody: Scalars['String']['input'];
    patientId: Scalars['UUID']['input'];
};

export type Service = {
    __typename?: 'Service';
    adminChangelogLink: Maybe<Scalars['String']['output']>;
    compatibility: ServiceCompatibilityEntrypoint;
    createdAt: Scalars['DateTime']['output'];
    description: Scalars['String']['output'];
    disciplines: Discipline[];
    durationMinutes: Scalars['Int']['output'];
    externalId: Maybe<Scalars['String']['output']>;
    externalIds: ExternalId[];
    flattenedQualifications: Qualification[];
    id: Scalars['UUID']['output'];
    instructions: Scalars['String']['output'];
    isVirtual: Scalars['Boolean']['output'];
    licenses: License[];
    name: Scalars['String']['output'];
    organization: Organization;
    patientClinicianSexMatchingLevel: MatchingLevel;
    payers: Payer[];
    priority: ServicePriority;
    qualificationsLegacy: QualificationAggregationSetDeprecated[];
    requiresAllQualifications: Scalars['Boolean']['output'];
    serviceBundles: ServiceBundle[];
    updatedAt: Scalars['DateTime']['output'];
};

export type ServiceDisciplinesArgs = {
    ordering?: InputMaybe<DisciplineOrdering>;
};

export type ServiceArea = {
    __typename?: 'ServiceArea';
    availableRadius: Scalars['Float']['output'];
    clinicAddress: Maybe<Address>;
    clinician: Maybe<Clinician>;
    externalIds: ExternalId[];
    id: Scalars['UUID']['output'];
    isActive: Scalars['Boolean']['output'];
    leadTime: Scalars['Int']['output'];
    maxContinuousTravelDuration: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    operatingHours: ServiceAreaDefaultAvailability[];
    organization: Maybe<Organization>;
    padding: Scalars['Int']['output'];
    serviceBundles: ServiceBundle[];
    territories: Territory[];
    tier: Maybe<Scalars['Int']['output']>;
    timezone: Scalars['String']['output'];
    typicalVisitDuration: Scalars['Int']['output'];
    useAlternateComms: Scalars['Boolean']['output'];
    useDynamicReachability: Scalars['Boolean']['output'];
    visitrequestTimeslotAlignmentMinutes: Scalars['Int']['output'];
    visitrequestTimeslotToleranceMinutes: Scalars['Int']['output'];
};

export type ServiceAreaDefaultAvailability = {
    __typename?: 'ServiceAreaDefaultAvailability';
    day: DayOfWeek;
    endTime: Scalars['String']['output'];
    serviceArea: ServiceArea;
    startTime: Scalars['String']['output'];
};

/** Expression of either an existing service area, or an indication that a service area should be inferred from the context in which this input is used. */
export type ServiceAreaExpressionInput = {
    /** If true, a service area will be inferred from the context (e.g., patient or order information). If it is not possible to infer a service area, an error will be thrown. */
    inferServiceArea?: InputMaybe<Scalars['Boolean']['input']>;
    /** If provided, the specified existing service area will be used. */
    serviceAreaId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ServiceAreaFilter = {
    AND?: InputMaybe<ServiceAreaFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<ServiceAreaFilter>;
    OR?: InputMaybe<ServiceAreaFilter>;
    clinicAddress?: InputMaybe<AddressFilter>;
    clinician?: InputMaybe<ClinicianFilter>;
    externalIds?: InputMaybe<ExternalIdFilter>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    isActive?: InputMaybe<BoolBaseFilterLookup>;
    name?: InputMaybe<StrFilterLookup>;
    organization?: InputMaybe<OrganizationFilter>;
    territories?: InputMaybe<TerritoryFilter>;
};

export type ServiceAreaOrdering = {
    clinician?: InputMaybe<ClinicianOrdering>;
    name?: InputMaybe<Ordering>;
    organization?: InputMaybe<OrganizationOrdering>;
};

export type ServiceAreaPaginatedList = {
    __typename?: 'ServiceAreaPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: ServiceArea[];
    totalCount: Scalars['Int']['output'];
};

export type ServiceAssignment = {
    clinicianId: Scalars['String']['input'];
    serviceIds: Scalars['UUID']['input'][];
};

export type ServiceBundle = {
    __typename?: 'ServiceBundle';
    createdAt: Scalars['DateTime']['output'];
    deletedAt: Maybe<Scalars['DateTime']['output']>;
    description: Scalars['String']['output'];
    durationMinutes: Scalars['NonNegativeInt']['output'];
    durationOverrideMinutes: Maybe<Scalars['PositiveInt']['output']>;
    id: Scalars['UUID']['output'];
    name: Scalars['String']['output'];
    organization: Organization;
    positions: ServiceBundlePosition[];
    updatedAt: Scalars['DateTime']['output'];
};

export type ServiceBundleFilter = {
    AND?: InputMaybe<ServiceBundleFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<ServiceBundleFilter>;
    OR?: InputMaybe<ServiceBundleFilter>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    name?: InputMaybe<StrFilterLookup>;
    services?: InputMaybe<ServiceFilter>;
};

export type ServiceBundlePosition = {
    __typename?: 'ServiceBundlePosition';
    durationMinutes: Scalars['NonNegativeInt']['output'];
    id: Scalars['UUID']['output'];
    isVirtual: Scalars['Boolean']['output'];
    serviceBundle: ServiceBundle;
    services: Service[];
    startOffsetMinutes: Scalars['NonNegativeInt']['output'];
};

export type ServiceBundlePositionAssignment = {
    clinicianId: Scalars['String']['input'];
    serviceBundlePositionId?: InputMaybe<Scalars['UUID']['input']>;
    serviceBundlePositionUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type ServiceBundlePositionClinicianAppointment =
    | ClinicianAppointment
    | ServiceBundlePosition;

export type ServiceCompatibilityEntrypoint = {
    __typename?: 'ServiceCompatibilityEntrypoint';
    withClinicians: Maybe<CliniciansCompatibilityResults>;
};

export type ServiceCompatibilityEntrypointWithCliniciansArgs = {
    clinicianFilters?: InputMaybe<ClinicianFilter>;
};

export type ServiceFilter = {
    AND?: InputMaybe<ServiceFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<ServiceFilter>;
    OR?: InputMaybe<ServiceFilter>;
    disciplines?: InputMaybe<DisciplineFilter>;
    externalIds?: InputMaybe<ExternalIdFilter>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    name?: InputMaybe<StrFilterLookup>;
    numPayers?: InputMaybe<IntComparisonFilterLookup>;
    organization?: InputMaybe<OrganizationFilter>;
    payers?: InputMaybe<PayerFilter>;
    qualifications?: InputMaybe<QualificationFilter>;
    searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceOrdering = {
    durationMinutes?: InputMaybe<Ordering>;
    name?: InputMaybe<Ordering>;
    priority?: InputMaybe<Ordering>;
};

export type ServicePaginatedList = {
    __typename?: 'ServicePaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: Service[];
    totalCount: Scalars['Int']['output'];
};

export enum ServicePriority {
    HIGH = 'HIGH',
    STANDARD = 'STANDARD',
    URGENT = 'URGENT',
}

export type SetPatientCommsPreferencesInput = {
    allowsAutomatedCalls?: InputMaybe<Scalars['Boolean']['input']>;
    allowsAutomatedEmails?: InputMaybe<Scalars['Boolean']['input']>;
    allowsAutomatedSms?: InputMaybe<Scalars['Boolean']['input']>;
    allowsClinicianCalls?: InputMaybe<Scalars['Boolean']['input']>;
    allowsClinicianSms?: InputMaybe<Scalars['Boolean']['input']>;
    patientId: Scalars['UUID']['input'];
};

export type SetPatientTimeslotPreferencesInput = {
    patientId: Scalars['UUID']['input'];
    timeslots: DayOfWeekTimeslotInput[];
};

export enum Sex {
    FEMALE = 'FEMALE',
    INTERSEX = 'INTERSEX',
    MALE = 'MALE',
    UNKNOWN = 'UNKNOWN',
}

export type ShiftBlockOccurrence = ScheduleEvent & {
    __typename?: 'ShiftBlockOccurrence';
    clinician: Maybe<Clinician>;
    createdAt: Scalars['DateTime']['output'];
    endDatetime: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    notes: Scalars['String']['output'];
    recurrence: ShiftBlockRecurrence;
    startDatetime: Scalars['DateTime']['output'];
    timezone: Scalars['Timezone']['output'];
};

export type ShiftBlockOccurrenceFilter = {
    clinician?: InputMaybe<ClinicianFilter>;
};

export type ShiftBlockRecurrence = RecurrenceRule & {
    __typename?: 'ShiftBlockRecurrence';
    adminChangelogLink: Maybe<Scalars['String']['output']>;
    allClinicians: Clinician[];
    clinicianTeams: ClinicianTeam[];
    clinicians: Clinician[];
    createdAt: Scalars['DateTime']['output'];
    createdFromRequest: Maybe<RequestToCreateShiftBlock>;
    deletedAt: Maybe<Scalars['DateTime']['output']>;
    endDatetime: Scalars['DateTime']['output'];
    excludeDatetimes: Scalars['DateTime']['output'][];
    id: Scalars['UUID']['output'];
    nextOccurrenceWindow: Maybe<TimeWindow>;
    notes: Scalars['String']['output'];
    numAllClinicians: Scalars['Int']['output'];
    occurrences: ShiftBlockOccurrence[];
    overlappingClinicianAppointments: Maybe<ClinicianAppointment[]>;
    overlappingVisits: Visit[];
    recurrenceRule: Scalars['String']['output'];
    startAddress: Maybe<Address>;
    startDatetime: Scalars['DateTime']['output'];
    timezone: Scalars['Timezone']['output'];
    untilDatetime: Maybe<Scalars['DateTime']['output']>;
    updatedAt: Scalars['DateTime']['output'];
};

export type ShiftBlockRecurrenceOccurrencesArgs = {
    endDatetime: Scalars['DateTime']['input'];
    filters?: InputMaybe<ShiftBlockOccurrenceFilter>;
    startDatetime: Scalars['DateTime']['input'];
};

export type ShiftBlockRecurrenceFilter = {
    AND?: InputMaybe<ShiftBlockRecurrenceFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<ShiftBlockRecurrenceFilter>;
    OR?: InputMaybe<ShiftBlockRecurrenceFilter>;
    clinicianTeams?: InputMaybe<ClinicianTeamFilter>;
    clinicians?: InputMaybe<ClinicianFilter>;
    createdAt?: InputMaybe<DatetimeDateFilterLookup>;
    endDatetime?: InputMaybe<DatetimeDateFilterLookup>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    notes?: InputMaybe<StrFilterLookup>;
    startDatetime?: InputMaybe<DatetimeDateFilterLookup>;
    updatedAt?: InputMaybe<DatetimeDateFilterLookup>;
};

export type ShiftBlockRecurrenceOrdering = {
    clinicianTeams?: InputMaybe<ClinicianTeamOrdering>;
    clinicians?: InputMaybe<ClinicianOrdering>;
    createdAt?: InputMaybe<Ordering>;
    endDatetime?: InputMaybe<Ordering>;
    notes?: InputMaybe<Ordering>;
    startDatetime?: InputMaybe<Ordering>;
    updatedAt?: InputMaybe<Ordering>;
};

export type ShiftBlockRecurrencePaginatedList = {
    __typename?: 'ShiftBlockRecurrencePaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: ShiftBlockRecurrence[];
    totalCount: Scalars['Int']['output'];
};

export type ShiftOccurrence = ScheduleEvent & {
    __typename?: 'ShiftOccurrence';
    clinician: Clinician;
    clinicianAppointments: ClinicianAppointment[];
    createdAt: Scalars['DateTime']['output'];
    distanceTraveled: Scalars['Float']['output'];
    endDatetime: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    isCanceled: Scalars['Boolean']['output'];
    isClinic: Scalars['Boolean']['output'];
    isComplete: Scalars['Boolean']['output'];
    isMobile: Scalars['Boolean']['output'];
    isVirtual: Scalars['Boolean']['output'];
    numClinicianAppointments: Scalars['Int']['output'];
    numVisits: Scalars['Int']['output'];
    recurrence: ShiftRecurrence;
    startDatetime: Scalars['DateTime']['output'];
    timezone: Scalars['Timezone']['output'];
    visits: Visit[];
};

export type ShiftRecurrence = RecurrenceRule & {
    __typename?: 'ShiftRecurrence';
    adminChangelogLink: Maybe<Scalars['String']['output']>;
    alwaysTrackLocation: Scalars['Boolean']['output'];
    cancellationOptions: DropReason[];
    clinic: Maybe<ServiceArea>;
    clinician: Clinician;
    createdAt: Scalars['DateTime']['output'];
    deletedAt: Maybe<Scalars['DateTime']['output']>;
    dropReason: Maybe<DropReason>;
    endAddress: Maybe<Address>;
    endDatetime: Scalars['DateTime']['output'];
    excludeDatetimes: Scalars['DateTime']['output'][];
    id: Scalars['UUID']['output'];
    isCanceled: Scalars['Boolean']['output'];
    isClinic: Scalars['Boolean']['output'];
    isMobile: Scalars['Boolean']['output'];
    isVirtual: Scalars['Boolean']['output'];
    mobileTerritories: Territory[];
    modalities: ShiftRecurrenceModality[];
    nextOccurrenceWindow: Maybe<TimeWindow>;
    notes: Scalars['String']['output'];
    occurrences: ShiftOccurrence[];
    qualificationRestrictions: ShiftRecurrenceQualificationRestriction[];
    recurrenceRule: Scalars['String']['output'];
    serviceLimits: ShiftRecurrenceServiceLimit[];
    startAddress: Maybe<Address>;
    startDatetime: Scalars['DateTime']['output'];
    timezone: Scalars['Timezone']['output'];
    untilDatetime: Maybe<Scalars['DateTime']['output']>;
    updatedAt: Scalars['DateTime']['output'];
    virtualTerritories: Territory[];
};

export type ShiftRecurrenceOccurrencesArgs = {
    endDatetime: Scalars['DateTime']['input'];
    startDatetime: Scalars['DateTime']['input'];
};

export type ShiftRecurrenceFilter = {
    AND?: InputMaybe<ShiftRecurrenceFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<ShiftRecurrenceFilter>;
    OR?: InputMaybe<ShiftRecurrenceFilter>;
    clinician?: InputMaybe<ClinicianFilter>;
    createdAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
    deletedAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
    endDatetime?: InputMaybe<DatetimeDatetimeFilterLookup>;
    hasRecurrence?: InputMaybe<BoolBaseFilterLookup>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    isCanceled?: InputMaybe<BoolBaseFilterLookup>;
    isClinic?: InputMaybe<BoolBaseFilterLookup>;
    isMobile?: InputMaybe<BoolBaseFilterLookup>;
    isVirtual?: InputMaybe<BoolBaseFilterLookup>;
    mayHaveFutureOccurrences?: InputMaybe<BoolBaseFilterLookup>;
    mobileTerritories?: InputMaybe<TerritoryFilter>;
    overlappingTerritories?: InputMaybe<TerritoryFilter>;
    recurrenceRule?: InputMaybe<StrFilterLookup>;
    startDatetime?: InputMaybe<DatetimeDatetimeFilterLookup>;
    updatedAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
    virtualTerritories?: InputMaybe<TerritoryFilter>;
};

export enum ShiftRecurrenceModality {
    CLINIC = 'CLINIC',
    MOBILE = 'MOBILE',
    VIRTUAL = 'VIRTUAL',
}

export type ShiftRecurrenceOrdering = {
    clinician?: InputMaybe<ClinicianOrdering>;
    notes?: InputMaybe<Ordering>;
    startDatetime?: InputMaybe<Ordering>;
};

export type ShiftRecurrencePaginatedList = {
    __typename?: 'ShiftRecurrencePaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: ShiftRecurrence[];
    totalCount: Scalars['Int']['output'];
};

export type ShiftRecurrenceQualificationRestriction = {
    __typename?: 'ShiftRecurrenceQualificationRestriction';
    endOffsetMinutes: Maybe<Scalars['Int']['output']>;
    expiredAtDatetime: Maybe<Scalars['DateTime']['output']>;
    qualification: Qualification;
    shiftRecurrence: ShiftRecurrence;
    startOffsetMinutes: Maybe<Scalars['Int']['output']>;
    startedAtDatetime: Maybe<Scalars['DateTime']['output']>;
};

export type ShiftRecurrenceServiceLimit = {
    __typename?: 'ShiftRecurrenceServiceLimit';
    id: Scalars['UUID']['output'];
    maxLimit: Scalars['Int']['output'];
    service: Service;
    shiftRecurrence: ShiftRecurrence;
};

export type StartClinicianSupportCallInput = {
    clinicianId: Scalars['UUID']['input'];
};

export type StartClinicianSupportCallResponse = {
    __typename?: 'StartClinicianSupportCallResponse';
    communications: ClinicianCommunications;
    toPhoneNumber: Scalars['PhoneE164']['output'];
};

export type StartDestinationCoordinatesInput = {
    destination: CoordinatesInput;
    start: CoordinatesInput;
};

export type StartPatientSupportCallInput = {
    patientId: Scalars['UUID']['input'];
};

export type StartPatientSupportCallResponse = {
    __typename?: 'StartPatientSupportCallResponse';
    communications: PatientCommunications;
    fromPhoneNumber: Scalars['PhoneE164']['output'];
};

export type StrBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<Scalars['String']['input']>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<Scalars['String']['input'][]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StrFilterLookup = {
    /** Case-sensitive containment test. Filter will be skipped on `null` value */
    contains?: InputMaybe<Scalars['String']['input']>;
    /** Case-sensitive ends-with. Filter will be skipped on `null` value */
    endsWith?: InputMaybe<Scalars['String']['input']>;
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<Scalars['String']['input']>;
    /** Case-insensitive containment test. Filter will be skipped on `null` value */
    iContains?: InputMaybe<Scalars['String']['input']>;
    /** Case-insensitive ends-with. Filter will be skipped on `null` value */
    iEndsWith?: InputMaybe<Scalars['String']['input']>;
    /** Case-insensitive exact match. Filter will be skipped on `null` value */
    iExact?: InputMaybe<Scalars['String']['input']>;
    /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
    iRegex?: InputMaybe<Scalars['String']['input']>;
    /** Case-insensitive starts-with. Filter will be skipped on `null` value */
    iStartsWith?: InputMaybe<Scalars['String']['input']>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<Scalars['String']['input'][]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
    /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
    regex?: InputMaybe<Scalars['String']['input']>;
    /** Case-sensitive starts-with. Filter will be skipped on `null` value */
    startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SyncAllPatientResourcesInput = {
    inRange?: InputMaybe<TimeWindowInput>;
    patientId: Scalars['UUID']['input'];
};

export type SyncRecord = {
    __typename?: 'SyncRecord';
    createdAt: Scalars['DateTime']['output'];
    hasError: Scalars['Boolean']['output'];
    id: Scalars['UUID']['output'];
    updatedAt: Scalars['DateTime']['output'];
    userSafeErrorMessage: Maybe<Scalars['String']['output']>;
    userSafeErrorPayload: Maybe<Scalars['JSON']['output']>;
    userSafeErrorType: Maybe<Scalars['String']['output']>;
};

export type SyncRecordFilter = {
    AND?: InputMaybe<SyncRecordFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<SyncRecordFilter>;
    OR?: InputMaybe<SyncRecordFilter>;
    createdAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
    hasError?: InputMaybe<BoolBaseFilterLookup>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    userSafeErrorPayload?: InputMaybe<JsonFilterLookup>;
    userSafeErrorType?: InputMaybe<StrFilterLookup>;
};

export type SyncRecordOrdering = {
    createdAt?: InputMaybe<Ordering>;
};

export type SyncRecordPaginatedList = {
    __typename?: 'SyncRecordPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: SyncRecord[];
    totalCount: Scalars['Int']['output'];
};

export enum SyncState {
    FAILING = 'FAILING',
    NEVER_ATTEMPTED = 'NEVER_ATTEMPTED',
    SUCCEEDING = 'SUCCEEDING',
}

export type SyncStateBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<SyncState>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<SyncState[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SyncStatus = {
    __typename?: 'SyncStatus';
    history: Maybe<SyncRecordPaginatedList>;
    id: Scalars['UUID']['output'];
    lastAttempt: Maybe<SyncRecord>;
    lastFailure: Maybe<SyncRecord>;
    lastSuccess: Maybe<SyncRecord>;
    state: SyncState;
};

export type SyncStatusHistoryArgs = {
    filters?: InputMaybe<SyncRecordFilter>;
    ordering?: InputMaybe<SyncRecordOrdering>;
    pagination?: InputMaybe<PaginationInput>;
};

export type SyncStatusFilter = {
    state?: InputMaybe<SyncStateBaseFilterLookup>;
};

export enum SyncableResourceType {
    CLINICIAN = 'CLINICIAN',
    CLINICIAN_APPOINTMENT = 'CLINICIAN_APPOINTMENT',
    EPISODE_OF_CARE = 'EPISODE_OF_CARE',
    ORDER = 'ORDER',
    PATIENT = 'PATIENT',
    VISIT = 'VISIT',
    VISIT_REQUEST = 'VISIT_REQUEST',
}

export type SystemMessageTemplate = {
    __typename?: 'SystemMessageTemplate';
    canCustomizeBeforeSending: Scalars['Boolean']['output'];
    enabled: Scalars['Boolean']['output'];
    frontendDescription: Scalars['String']['output'];
    frontendLabel: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastSent: Maybe<Communication>;
    messageBody: Scalars['String']['output'];
    messageTypeKey: Scalars['String']['output'];
};

export type TentativeAssignment = {
    __typename?: 'TentativeAssignment';
    clinicianAppointment: ClinicianAppointment;
    tentativeClinician: Clinician;
};

export type TentativeAssignmentInput = {
    clinicianAppointmentId: Scalars['UUID']['input'];
    clinicianId?: InputMaybe<Scalars['UUID']['input']>;
};

export type TentativeRoutedVisit = {
    __typename?: 'TentativeRoutedVisit';
    tentativeAssignments: TentativeAssignment[];
    tentativeStartDatetime: Scalars['DateTime']['output'];
    visit: Visit;
};

export type TentativeShiftBlockOccurrence = ScheduleEvent & {
    __typename?: 'TentativeShiftBlockOccurrence';
    createdAt: Scalars['DateTime']['output'];
    endDatetime: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    notes: Scalars['String']['output'];
    parentRequest: RequestToCreateShiftBlock;
    startDatetime: Scalars['DateTime']['output'];
    state: ScheduleChangeRequestState;
    timezone: Scalars['Timezone']['output'];
};

export type TentativeShiftOccurrence = ScheduleEvent & {
    __typename?: 'TentativeShiftOccurrence';
    createdAt: Scalars['DateTime']['output'];
    endDatetime: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    notes: Scalars['String']['output'];
    parentRequest: RequestToCreateShift;
    startDatetime: Scalars['DateTime']['output'];
    state: ScheduleChangeRequestState;
    timezone: Scalars['Timezone']['output'];
};

export type TentativeVisitScheduleAndAssignments = {
    clinicianAppointmentAssignments?: InputMaybe<TentativeAssignmentInput[]>;
    startDatetime: Scalars['DateTime']['input'];
    visitId: Scalars['UUID']['input'];
};

export type Territory = {
    __typename?: 'Territory';
    adminChangelogLink: Maybe<Scalars['String']['output']>;
    centroid: Maybe<Coordinates>;
    clinicians: Clinician[];
    cliniciansMobile: Clinician[];
    cliniciansVirtual: Clinician[];
    id: Scalars['UUID']['output'];
    isArchived: Scalars['Boolean']['output'];
    isLocked: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    organization: Organization;
    serviceAreas: ServiceArea[];
    zipCodes: Scalars['String']['output'][];
};

export type TerritoryFilter = {
    AND?: InputMaybe<TerritoryFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<TerritoryFilter>;
    OR?: InputMaybe<TerritoryFilter>;
    clinicians?: InputMaybe<ClinicianFilter>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    isArchived?: InputMaybe<BoolBaseFilterLookup>;
    isLocked?: InputMaybe<BoolBaseFilterLookup>;
    name?: InputMaybe<StrFilterLookup>;
    organization?: InputMaybe<OrganizationFilter>;
    serviceAreas?: InputMaybe<ServiceAreaFilter>;
};

export type TerritoryOrdering = {
    name?: InputMaybe<Ordering>;
    organization?: InputMaybe<OrganizationOrdering>;
};

export type TerritoryPaginatedList = {
    __typename?: 'TerritoryPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: Territory[];
    totalCount: Scalars['Int']['output'];
};

export type TimeRangeLookup = {
    end?: InputMaybe<Scalars['Time']['input']>;
    start?: InputMaybe<Scalars['Time']['input']>;
};

export type TimeTimeFilterLookup = {
    date?: InputMaybe<IntComparisonFilterLookup>;
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<Scalars['Time']['input']>;
    /** Greater than. Filter will be skipped on `null` value */
    gt?: InputMaybe<Scalars['Time']['input']>;
    /** Greater than or equal to. Filter will be skipped on `null` value */
    gte?: InputMaybe<Scalars['Time']['input']>;
    hour?: InputMaybe<IntComparisonFilterLookup>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<Scalars['Time']['input'][]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
    /** Less than. Filter will be skipped on `null` value */
    lt?: InputMaybe<Scalars['Time']['input']>;
    /** Less than or equal to. Filter will be skipped on `null` value */
    lte?: InputMaybe<Scalars['Time']['input']>;
    minute?: InputMaybe<IntComparisonFilterLookup>;
    /** Inclusive range test (between) */
    range?: InputMaybe<TimeRangeLookup>;
    second?: InputMaybe<IntComparisonFilterLookup>;
    time?: InputMaybe<IntComparisonFilterLookup>;
};

export type TimeWindow = {
    __typename?: 'TimeWindow';
    end: Scalars['DateTime']['output'];
    endDatetime: Scalars['DateTime']['output'];
    start: Scalars['DateTime']['output'];
    startDatetime: Scalars['DateTime']['output'];
};

export type TimeWindowInput = {
    endDatetime: Scalars['DateTime']['input'];
    startDatetime: Scalars['DateTime']['input'];
};

export type TimestampedCoordinates = {
    __typename?: 'TimestampedCoordinates';
    coordinates: Coordinates;
    timestamp: Scalars['DateTime']['output'];
};

export type TripTask = {
    __typename?: 'TripTask';
    clinician: Clinician;
    createdAt: Maybe<Scalars['DateTime']['output']>;
    destinationAddress: Maybe<Address>;
    distanceTraveledMiles: Maybe<Scalars['Float']['output']>;
    id: Scalars['UUID']['output'];
    notes: Maybe<Scalars['String']['output']>;
    status: Maybe<TripTaskStatus>;
    tripType: Maybe<TripTaskType>;
    updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type TripTaskFilter = {
    AND?: InputMaybe<TripTaskFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<TripTaskFilter>;
    OR?: InputMaybe<TripTaskFilter>;
    clinician?: InputMaybe<ClinicianFilter>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    notes?: InputMaybe<StrFilterLookup>;
    status?: InputMaybe<TripTaskStatusBaseFilterLookup>;
    type?: InputMaybe<TripTaskTypeBaseFilterLookup>;
};

export type TripTaskOrdering = {
    createdAt?: InputMaybe<Ordering>;
    updatedAt?: InputMaybe<Ordering>;
};

export type TripTaskPaginatedList = {
    __typename?: 'TripTaskPaginatedList';
    addresses: Address[];
    hasMore: Scalars['Boolean']['output'];
    items: TripTask[];
    totalCount: Scalars['Int']['output'];
};

export enum TripTaskStatus {
    ARRIVED = 'ARRIVED',
    EN_ROUTE = 'EN_ROUTE',
    FAILED = 'FAILED',
    NOT_STARTED = 'NOT_STARTED',
    SUCCEEDED = 'SUCCEEDED',
}

export type TripTaskStatusBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<TripTaskStatus>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<TripTaskStatus[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TripTaskType {
    HOME = 'HOME',
    LAB = 'LAB',
    PHARMACY = 'PHARMACY',
    SHIPPING = 'SHIPPING',
}

export type TripTaskTypeBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<TripTaskType>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<TripTaskType[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UuidBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<Scalars['UUID']['input']>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<Scalars['UUID']['input'][]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UnarchiveTerritoryInput = {
    territoryId: Scalars['UUID']['input'];
};

export type UnconfirmedAvailabilityInput = {
    address: AddressInput;
    appointments?: InputMaybe<Appointment[]>;
    serviceAreaId: Scalars['UUID']['input'];
    serviceBundleIds?: InputMaybe<Scalars['UUID']['input'][]>;
};

export type UnlockTerritoryInput = {
    territoryId: Scalars['UUID']['input'];
};

export type UpdateVisitRequestAppointmentClinicianAssignmentInput = {
    clinicianAppointmentId: Scalars['UUID']['input'];
    clinicianId?: InputMaybe<Scalars['UUID']['input']>;
    visitRequestId: Scalars['UUID']['input'];
};

export type UpdateVisitRequestClinicianAppointmentServicesInput = {
    clinicianAppointmentId?: InputMaybe<Scalars['UUID']['input']>;
    serviceIds: Scalars['UUID']['input'][];
    visitRequestId: Scalars['UUID']['input'];
};

export type UpdateVisitRequestTentativeDateInput = {
    tentativeDate?: InputMaybe<Scalars['Date']['input']>;
    visitRequestId: Scalars['UUID']['input'];
};

export type User = {
    __typename?: 'User';
    clinician: Maybe<Clinician>;
    createdAt: Scalars['DateTime']['output'];
    dashboardRoles: UserRole[];
    email: Scalars['Email']['output'];
    firstName: Scalars['String']['output'];
    fullName: Scalars['String']['output'];
    id: Scalars['UUID']['output'];
    isActive: Scalars['Boolean']['output'];
    isDashboardUser: Scalars['Boolean']['output'];
    lastName: Scalars['String']['output'];
    organization: Organization;
    phoneNumber: Scalars['PhoneE164']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type UserFilter = {
    AND?: InputMaybe<UserFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<UserFilter>;
    OR?: InputMaybe<UserFilter>;
    email?: InputMaybe<StrFilterLookup>;
    firstName?: InputMaybe<StrFilterLookup>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    isActive?: InputMaybe<BoolBaseFilterLookup>;
    isDashboardUser?: InputMaybe<BoolBaseFilterLookup>;
    lastName?: InputMaybe<StrFilterLookup>;
    organization?: InputMaybe<OrganizationFilter>;
    phoneNumber?: InputMaybe<StrFilterLookup>;
};

export type UserOrdering = {
    createdAt?: InputMaybe<Ordering>;
    firstName?: InputMaybe<Ordering>;
    fullName?: InputMaybe<Ordering>;
    lastName?: InputMaybe<Ordering>;
    organization?: InputMaybe<OrganizationOrdering>;
    updatedAt?: InputMaybe<Ordering>;
};

export type UserPaginatedList = {
    __typename?: 'UserPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: User[];
    totalCount: Scalars['Int']['output'];
};

export type UserRole = {
    __typename?: 'UserRole';
    description: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
};

export type Visit = {
    __typename?: 'Visit';
    address: Address;
    adminChangelogLink: Maybe<Scalars['String']['output']>;
    answers: VisitAnswer[];
    areClinicianQuestionsComplete: Scalars['Boolean']['output'];
    arePatientQuestionsComplete: Scalars['Boolean']['output'];
    assignedClinicians: Clinician[];
    cancellationReason: Maybe<OptionValue>;
    childVisits: Visit[];
    clinicianAppointments: Maybe<ClinicianAppointment[]>;
    communications: VisitCommunications;
    compatibleOrdersForAssociation: Maybe<Order[]>;
    computedPriority: VisitPriority;
    contact: Maybe<Contact>;
    createdAt: Scalars['DateTime']['output'];
    createdFromServiceBundle: Maybe<ServiceBundle>;
    /** @deprecated Use effective_date instead */
    date: Maybe<Scalars['Date']['output']>;
    decisionSupport: VisitDecisionSupport;
    demandOrganization: Organization;
    disciplines: Discipline[];
    documents: Document[];
    durationMinutes: Scalars['Int']['output'];
    durationOverrideMinutes: Maybe<Scalars['Int']['output']>;
    effectiveDate: Maybe<Scalars['Date']['output']>;
    effectivePriority: VisitPriority;
    encounters: Encounter[];
    endDatetime: Maybe<Scalars['DateTime']['output']>;
    episode: Maybe<EpisodeOfCare>;
    extensions: Maybe<Scalars['JSON']['output']>;
    externalId: Scalars['String']['output'];
    externalIds: ExternalId[];
    externalLink: Maybe<Scalars['String']['output']>;
    fulfillmentWindow: Maybe<OptionalTimeWindow>;
    hasOrder: Scalars['Boolean']['output'];
    hasVisitRequest: Scalars['Boolean']['output'];
    id: Scalars['UUID']['output'];
    /** @deprecated Use notesForDashboard instead */
    internalNotes: Scalars['String']['output'];
    isCompleted: Scalars['Boolean']['output'];
    metadata: Maybe<Scalars['JSON']['output']>;
    notesForClinician: Scalars['String']['output'];
    notesForDashboard: Maybe<Scalars['String']['output']>;
    numClinicianAppointments: Scalars['Int']['output'];
    numPreferredTimeslots: Scalars['Int']['output'];
    order: Maybe<Order>;
    organization: Organization;
    outcome: VisitOutcome;
    parentVisit: Maybe<Visit>;
    patient: Patient;
    permissions: VisitPermissions;
    preferredTimeslotOptions: TimeWindow[];
    preferredTimeslots: VisitTimeslotPreference[];
    priority: Maybe<VisitPriority>;
    questions: VisitQuestion[];
    questionsForClinician: VisitQuestion[];
    questionsForPatient: VisitQuestion[];
    requiresReschedule: Maybe<Scalars['Boolean']['output']>;
    reviews: Maybe<VisitReview[]>;
    serviceArea: ServiceArea;
    services: Service[];
    startDatetime: Maybe<Scalars['DateTime']['output']>;
    state: VisitState;
    stateChanges: VisitStateChange[];
    supplyOrganization: Organization;
    syncStatus: Maybe<SyncStatus>;
    tentativeDate: Maybe<Scalars['Date']['output']>;
    timezone: Scalars['Timezone']['output'];
    travelPath: Maybe<TimestampedCoordinates[]>;
    updatedAt: Scalars['DateTime']['output'];
    visitOrder: Maybe<VisitOrder>;
    visitRequests: VisitRequest[];
    warnings: VisitWarning[];
};

export type VisitCompatibleOrdersForAssociationArgs = {
    filters?: InputMaybe<OrderFilter>;
};

export type VisitDisciplinesArgs = {
    ordering?: InputMaybe<DisciplineOrdering>;
};

export type VisitPreferredTimeslotOptionsArgs = {
    requestedEndDatetime?: InputMaybe<Scalars['DateTime']['input']>;
    requestedStartDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VisitQuestionsForClinicianArgs = {
    onlyRequiredQuestions?: Scalars['Boolean']['input'];
};

export type VisitAnswer = {
    __typename?: 'VisitAnswer';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['UUID']['output'];
    question: VisitQuestion;
    updatedAt: Scalars['DateTime']['output'];
    value: Scalars['JSON']['output'];
};

export type VisitClinicianAppointmentClinicianRecommendations = {
    __typename?: 'VisitClinicianAppointmentClinicianRecommendations';
    allClinicians: VisitishClinicianAppointmentClinicianRecommendation[];
    allCliniciansAtInsertionTime: VisitishClinicianAppointmentClinicianRecommendation[];
    allCliniciansGivenOtherRecommendations: VisitishClinicianAppointmentClinicianRecommendation[];
    clinicianAppointment: ClinicianAppointment;
    compatibility: Maybe<CliniciansCompatibilityResults>;
    insertionOrder: Scalars['Int']['output'];
    recommendedClinician: Maybe<VisitishClinicianAppointmentClinicianRecommendation>;
    recommendedCliniciansAtInsertionTime: VisitishClinicianAppointmentClinicianRecommendation[];
    recommendedCliniciansGivenOtherRecommendations: VisitishClinicianAppointmentClinicianRecommendation[];
};

export type VisitClinicianAppointmentDecisionSupport = {
    __typename?: 'VisitClinicianAppointmentDecisionSupport';
    clinicianAppointment: ClinicianAppointment;
    clinicianRecommendations: Maybe<VisitClinicianAppointmentClinicianRecommendations>;
    id: Scalars['UUID']['output'];
};

export type VisitClinicianAppointmentDecisionSupportClinicianRecommendationsArgs = {
    clinicianFilters?: InputMaybe<ClinicianFilter>;
};

export type VisitCommunications = {
    __typename?: 'VisitCommunications';
    areActive: Scalars['Boolean']['output'];
    areCurrentClinicianPatientCommunicationsActive: Scalars['Boolean']['output'];
    areLeadClinicianPatientCommunicationsActive: Scalars['Boolean']['output'];
    clinicianSendableSystemMessageTemplates: Maybe<SystemMessageTemplate[]>;
    id: Scalars['UUID']['output'];
    numUnreadPatientClinicianCommunications: Scalars['Int']['output'];
    patientClinicianCommunications: Maybe<Communication[]>;
    patientSystemCommunications: Maybe<Communication[]>;
};

export type VisitCommunicationsPatientClinicianCommunicationsArgs = {
    filters?: InputMaybe<CommunicationFilter>;
    ordering?: InputMaybe<CommunicationOrdering>;
};

export type VisitCommunicationsPatientSystemCommunicationsArgs = {
    filters?: InputMaybe<CommunicationFilter>;
    ordering?: InputMaybe<CommunicationOrdering>;
};

export type VisitDateRecommendations = {
    __typename?: 'VisitDateRecommendations';
    allDatesGivenOtherRecommendations: VisitishDateRecommendation[];
    recommendedDate: Maybe<VisitishDateRecommendation>;
    recommendedDatesGivenOtherRecommendations: VisitishDateRecommendation[];
    visit: Visit;
};

export enum VisitDatetimeField {
    CREATED_AT = 'CREATED_AT',
    EARLIEST_START_DATETIME = 'EARLIEST_START_DATETIME',
    EFFECTIVE_DATE = 'EFFECTIVE_DATE',
    END_DATETIME = 'END_DATETIME',
    LATEST_END_DATETIME = 'LATEST_END_DATETIME',
    START_DATETIME = 'START_DATETIME',
    TENTATIVE_DATE = 'TENTATIVE_DATE',
    UPDATED_AT = 'UPDATED_AT',
}

export type VisitDecisionSupport = {
    __typename?: 'VisitDecisionSupport';
    clinicianRecommendations: Maybe<VisitClinicianAppointmentClinicianRecommendations[]>;
    dateRecommendations: Maybe<VisitDateRecommendations>;
    id: Scalars['UUID']['output'];
    visit: Visit;
};

export type VisitDecisionSupportClinicianRecommendationsArgs = {
    clinicianFilters?: InputMaybe<ClinicianFilter>;
};

export type VisitFilter = {
    AND?: InputMaybe<VisitFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<VisitFilter>;
    OR?: InputMaybe<VisitFilter>;
    areCommsActive?: InputMaybe<Scalars['Boolean']['input']>;
    assignedClinicianTeams?: InputMaybe<ClinicianTeamFilter>;
    assignedClinicians?: InputMaybe<ClinicianFilter>;
    cancellationReason?: InputMaybe<OptionValueFilter>;
    careTeams?: InputMaybe<CareTeamFilter>;
    clinicianAppointments?: InputMaybe<ClinicianAppointmentFilter>;
    computedPriority?: InputMaybe<VisitPriorityBaseFilterLookup>;
    createdAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
    createdFromServiceBundle?: InputMaybe<ServiceBundleFilter>;
    disciplineCoveredByCareTeam?: InputMaybe<BoolBaseFilterLookup>;
    disciplines?: InputMaybe<DisciplineFilter>;
    earliestStartDatetime?: InputMaybe<DatetimeDatetimeFilterLookup>;
    effectiveDate?: InputMaybe<DateDateFilterLookup>;
    effectivePriority?: InputMaybe<VisitPriorityBaseFilterLookup>;
    endDatetime?: InputMaybe<DatetimeDatetimeFilterLookup>;
    episode?: InputMaybe<EpisodeOfCareFilter>;
    externalId?: InputMaybe<StrBaseFilterLookup>;
    externalIds?: InputMaybe<ExternalIdFilter>;
    hasEpisode?: InputMaybe<BoolBaseFilterLookup>;
    hasOrder?: InputMaybe<BoolBaseFilterLookup>;
    hasVisitRequest?: InputMaybe<BoolBaseFilterLookup>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    inDateWindow?: InputMaybe<DateWindowInput>;
    latestEndDatetime?: InputMaybe<DatetimeDatetimeFilterLookup>;
    metadata?: InputMaybe<JsonjsonFilterLookup>;
    needsAttention?: InputMaybe<BoolBaseFilterLookup>;
    needsClinicians?: InputMaybe<BoolBaseFilterLookup>;
    notesForClinician?: InputMaybe<StrFilterLookup>;
    notesForDashboard?: InputMaybe<StrFilterLookup>;
    numClinicianAppointments?: InputMaybe<IntComparisonFilterLookup>;
    numPreferredTimeslots?: InputMaybe<IntComparisonFilterLookup>;
    organization?: InputMaybe<OrganizationFilter>;
    outcome?: InputMaybe<VisitOutcomeBaseFilterLookup>;
    patient?: InputMaybe<PatientFilter>;
    preferredTimeslots?: InputMaybe<VisitTimeslotPreferenceFilter>;
    priority?: InputMaybe<VisitPriorityBaseFilterLookup>;
    qualifications?: InputMaybe<QualificationFilter>;
    relatedOrder?: InputMaybe<OrderFilter>;
    relatedVisitCondition?: InputMaybe<RelatedVisitConditionInput>;
    requiresReschedule?: InputMaybe<BoolBaseFilterLookup>;
    scheduledOrPlannedInDateWindow?: InputMaybe<DateWindowInput>;
    scheduledOrPlannedInWindow?: InputMaybe<TimeWindowInput>;
    searchTerm?: InputMaybe<Scalars['String']['input']>;
    serviceArea?: InputMaybe<ServiceAreaFilter>;
    services?: InputMaybe<ServiceFilter>;
    startDatetime?: InputMaybe<DatetimeDatetimeFilterLookup>;
    state?: InputMaybe<VisitStateBaseFilterLookup>;
    supplyOrganization?: InputMaybe<OrganizationFilter>;
    syncStatus?: InputMaybe<SyncStatusFilter>;
    tentativeDate?: InputMaybe<DateDateFilterLookup>;
    territory?: InputMaybe<TerritoryFilter>;
    timeslotpreferencesRange?: InputMaybe<VisitTimeslotPreferenceInput>;
    timezone?: InputMaybe<StrFilterLookup>;
    updatedAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
};

export type VisitOrder = {
    __typename?: 'VisitOrder';
    address: Address;
    createdAt: Scalars['DateTime']['output'];
    duration: Maybe<Scalars['Int']['output']>;
    externalId: Maybe<Scalars['String']['output']>;
    fromDate: Maybe<Scalars['Date']['output']>;
    id: Scalars['UUID']['output'];
    maxVisitsPerUnitTime: Maybe<Scalars['Int']['output']>;
    minVisitsPerUnitTime: Maybe<Scalars['Int']['output']>;
    orderNotes: Scalars['String']['output'];
    outcome: Maybe<VisitOrderOutcome>;
    patient: Maybe<Patient>;
    serviceBundles: Maybe<ServiceBundle[]>;
    state: VisitOrderState;
    timezone: Scalars['Timezone']['output'];
    toDate: Maybe<Scalars['Date']['output']>;
    unitTimeWeeks: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTime']['output'];
};

export type VisitOrderFilter = {
    AND?: InputMaybe<VisitOrderFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<VisitOrderFilter>;
    OR?: InputMaybe<VisitOrderFilter>;
    outcome?: InputMaybe<VisitOrderOutcomeBaseFilterLookup>;
    patient?: InputMaybe<PatientFilter>;
    searchTerm?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<VisitOrderStateBaseFilterLookup>;
};

export type VisitOrderOrdering = {
    patient?: InputMaybe<PatientOrdering>;
    updatedAt?: InputMaybe<Ordering>;
};

export enum VisitOrderOutcome {
    CANCELED = 'CANCELED',
    COMPLETED = 'COMPLETED',
    DISCONTINUED = 'DISCONTINUED',
    EXTENDED = 'EXTENDED',
    NONE = 'NONE',
}

export type VisitOrderOutcomeBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<VisitOrderOutcome>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<VisitOrderOutcome[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VisitOrderPaginatedList = {
    __typename?: 'VisitOrderPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: VisitOrder[];
    totalCount: Scalars['Int']['output'];
};

export enum VisitOrderState {
    ACTIVE = 'ACTIVE',
    DRAFT = 'DRAFT',
    ENDED = 'ENDED',
    NEEDS_ATTENTION = 'NEEDS_ATTENTION',
    NEEDS_OUTCOME = 'NEEDS_OUTCOME',
}

export type VisitOrderStateBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<VisitOrderState>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<VisitOrderState[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VisitOrdering = {
    cancellationReason?: InputMaybe<OptionValueOrdering>;
    createdAt?: InputMaybe<Ordering>;
    earliestStartDatetime?: InputMaybe<Ordering>;
    effectiveDate?: InputMaybe<Ordering>;
    endDatetime?: InputMaybe<Ordering>;
    episode?: InputMaybe<EpisodeOfCareOrdering>;
    latestEndDatetime?: InputMaybe<Ordering>;
    organization?: InputMaybe<OrganizationOrdering>;
    patient?: InputMaybe<PatientOrdering>;
    searchRanking?: InputMaybe<Ordering>;
    startDatetime?: InputMaybe<Ordering>;
    tentativeDate?: InputMaybe<Ordering>;
    updatedAt?: InputMaybe<Ordering>;
};

export enum VisitOutcome {
    COMPLETED = 'COMPLETED',
    MISSED = 'MISSED',
    NONE = 'NONE',
    OTHER = 'OTHER',
    PATIENT_CANCELED = 'PATIENT_CANCELED',
    PATIENT_DID_NOT_SHOW = 'PATIENT_DID_NOT_SHOW',
    PATIENT_LATE_CANCELED = 'PATIENT_LATE_CANCELED',
    UNAVAILABLE = 'UNAVAILABLE',
    UNSUCCESSFUL = 'UNSUCCESSFUL',
}

export type VisitOutcomeBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<VisitOutcome>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<VisitOutcome[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VisitPaginatedList = {
    __typename?: 'VisitPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: Visit[];
    totalCount: Scalars['Int']['output'];
};

export type VisitPermissions = {
    __typename?: 'VisitPermissions';
    assign: Scalars['Boolean']['output'];
    cancel: Scalars['Boolean']['output'];
    editAddress: Scalars['Boolean']['output'];
    editDistanceTraveled: Scalars['Boolean']['output'];
    editDocuments: Scalars['Boolean']['output'];
    editNotesForClinician: Scalars['Boolean']['output'];
    editNotesForDashboard: Scalars['Boolean']['output'];
    editOutcome: Scalars['Boolean']['output'];
    editPriority: Scalars['Boolean']['output'];
    editServices: Scalars['Boolean']['output'];
    editState: Scalars['Boolean']['output'];
    editWithCompletedOutcome: Scalars['Boolean']['output'];
    id: Scalars['UUID']['output'];
    markIncompleteWithRequiresReschedule: Scalars['Boolean']['output'];
    markMissed: Scalars['Boolean']['output'];
    reschedule: Scalars['Boolean']['output'];
    rescheduleWithinFulfillmentWindow: Scalars['Boolean']['output'];
    sameDayReschedule: Scalars['Boolean']['output'];
    viewAssignedClinicians: Scalars['Boolean']['output'];
    viewCommunications: Scalars['Boolean']['output'];
    viewDocuments: Scalars['Boolean']['output'];
    viewOrder: Scalars['Boolean']['output'];
    viewStateChanges: Scalars['Boolean']['output'];
    viewVisitOrderDetails: Scalars['Boolean']['output'];
};

export enum VisitPriority {
    HIGH = 'HIGH',
    STANDARD = 'STANDARD',
    URGENT = 'URGENT',
}

export type VisitPriorityBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<VisitPriority>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<VisitPriority[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VisitQuestion = {
    __typename?: 'VisitQuestion';
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['UUID']['output'];
    isClinicianRespondent: Scalars['Boolean']['output'];
    isPatientRespondent: Scalars['Boolean']['output'];
    isRequired: Scalars['Boolean']['output'];
    options: Maybe<Scalars['JSON']['output']>;
    organization: Organization;
    questionType: QuestionType;
    title: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type VisitRequest = {
    __typename?: 'VisitRequest';
    address: Maybe<Address>;
    adminChangelogLink: Maybe<Scalars['String']['output']>;
    appointments: VisitRequestAppointment[];
    assignedClinicians: Clinician[];
    availableClinicians: Clinician[];
    availableServices: Service[];
    compatibleOrdersForAssociation: Maybe<Order[]>;
    createdAt: Scalars['DateTime']['output'];
    decisionSupport: VisitRequestDecisionSupport;
    disciplines: Discipline[];
    effectiveDate: Maybe<Scalars['Date']['output']>;
    episode: Maybe<EpisodeOfCare>;
    externalId: Maybe<Scalars['String']['output']>;
    externalIds: ExternalId[];
    externalLink: Maybe<Scalars['String']['output']>;
    fulfillmentWindow: Maybe<DateFulfillmentWindow>;
    hasAddress: Scalars['Boolean']['output'];
    hasOrder: Scalars['Boolean']['output'];
    hasVisit: Scalars['Boolean']['output'];
    id: Scalars['UUID']['output'];
    metadata: Maybe<Scalars['JSON']['output']>;
    needsClinicians: Scalars['Boolean']['output'];
    needsServices: Scalars['Boolean']['output'];
    notes: Maybe<Scalars['String']['output']>;
    numClinicianAppointments: Scalars['Int']['output'];
    order: Maybe<Order>;
    organization: Organization;
    patient: Patient;
    permissions: VisitRequestPermissions;
    priority: VisitPriority;
    serviceArea: Maybe<ServiceArea>;
    services: Service[];
    state: VisitRequestState;
    syncStatus: Maybe<SyncStatus>;
    tentativeDate: Maybe<Scalars['Date']['output']>;
    timezone: Maybe<Scalars['Timezone']['output']>;
    updatedAt: Scalars['DateTime']['output'];
    visit: Maybe<Visit>;
    visitBookingNotes: Maybe<Scalars['String']['output']>;
    visitInternalNotes: Maybe<Scalars['String']['output']>;
    warnings: VisitRequestWarning[];
    workflowStep: VisitRequestWorkflowStep;
};

export type VisitRequestCompatibleOrdersForAssociationArgs = {
    filters?: InputMaybe<OrderFilter>;
};

export type VisitRequestDisciplinesArgs = {
    ordering?: InputMaybe<DisciplineOrdering>;
};

export type VisitRequestAppointment = {
    __typename?: 'VisitRequestAppointment';
    clinician: Maybe<Clinician>;
    createdAt: Scalars['DateTime']['output'];
    decisionSupport: VisitRequestClinicianAppointmentDecisionSupport;
    id: Scalars['UUID']['output'];
    services: Service[];
    updatedAt: Scalars['DateTime']['output'];
    visitRequest: VisitRequest;
};

export type VisitRequestBulkMutationResult = {
    __typename?: 'VisitRequestBulkMutationResult';
    errors: Maybe<BulkMutationError[]>;
    resource: Maybe<VisitRequest>;
    success: Scalars['Boolean']['output'];
};

export type VisitRequestClinicianAppointmentClinicianRecommendations = {
    __typename?: 'VisitRequestClinicianAppointmentClinicianRecommendations';
    allClinicians: VisitishClinicianAppointmentClinicianRecommendation[];
    allCliniciansAtInsertionTime: VisitishClinicianAppointmentClinicianRecommendation[];
    allCliniciansGivenOtherRecommendations: VisitishClinicianAppointmentClinicianRecommendation[];
    clinicianAppointment: VisitRequestAppointment;
    compatibility: Maybe<CliniciansCompatibilityResults>;
    insertionOrder: Scalars['Int']['output'];
    recommendedClinician: Maybe<VisitishClinicianAppointmentClinicianRecommendation>;
    /** @deprecated Use recommended_clinician and recommended_clinicians_given_other_recommendations instead. */
    recommendedClinicians: VisitishClinicianAppointmentClinicianRecommendation[];
    recommendedCliniciansAtInsertionTime: VisitishClinicianAppointmentClinicianRecommendation[];
    recommendedCliniciansGivenOtherRecommendations: VisitishClinicianAppointmentClinicianRecommendation[];
};

export type VisitRequestClinicianAppointmentDecisionSupport = {
    __typename?: 'VisitRequestClinicianAppointmentDecisionSupport';
    clinicianAppointment: VisitRequestAppointment;
    clinicianRecommendations: Maybe<VisitRequestClinicianAppointmentClinicianRecommendations>;
    id: Scalars['UUID']['output'];
};

export type VisitRequestClinicianAppointmentDecisionSupportClinicianRecommendationsArgs = {
    clinicianFilters?: InputMaybe<ClinicianFilter>;
};

export type VisitRequestDateRecommendations = {
    __typename?: 'VisitRequestDateRecommendations';
    /** @deprecated Use recommended_date and all_dates_given_other_recommendations instead. */
    allDates: VisitishDateRecommendation[];
    allDatesGivenOtherRecommendations: VisitishDateRecommendation[];
    /** @deprecated Use recommended_date and recommended_dates_given_other_recommendations instead. */
    dates: VisitishDateRecommendation[];
    recommendedDate: Maybe<VisitishDateRecommendation>;
    /** @deprecated Use recommended_dates and recommended_dates_given_other_recommendations instead. */
    recommendedDates: VisitishDateRecommendation[];
    recommendedDatesGivenOtherRecommendations: VisitishDateRecommendation[];
    visitRequest: VisitRequest;
};

export type VisitRequestDecisionSupport = {
    __typename?: 'VisitRequestDecisionSupport';
    clinicianRecommendations: Maybe<VisitRequestClinicianAppointmentClinicianRecommendations[]>;
    dateRecommendations: Maybe<VisitRequestDateRecommendations>;
    id: Scalars['UUID']['output'];
    visitRequest: VisitRequest;
};

export type VisitRequestDecisionSupportClinicianRecommendationsArgs = {
    clinicianFilters?: InputMaybe<ClinicianFilter>;
};

export type VisitRequestFilter = {
    AND?: InputMaybe<VisitRequestFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<VisitRequestFilter>;
    OR?: InputMaybe<VisitRequestFilter>;
    assignedClinicianTeams?: InputMaybe<ClinicianTeamFilter>;
    assignedClinicians?: InputMaybe<ClinicianFilter>;
    careTeams?: InputMaybe<CareTeamFilter>;
    disciplineCoveredByCareTeam?: InputMaybe<BoolBaseFilterLookup>;
    disciplines?: InputMaybe<DisciplineFilter>;
    effectiveDate?: InputMaybe<DateDateFilterLookup>;
    episode?: InputMaybe<EpisodeOfCareFilter>;
    externalId?: InputMaybe<StrBaseFilterLookup>;
    externalIds?: InputMaybe<ExternalIdFilter>;
    fulfillmentWindowEndDate?: InputMaybe<DateDateFilterLookup>;
    fulfillmentWindowMatchesOrderFulfillmentWindow?: InputMaybe<BoolBaseFilterLookup>;
    fulfillmentWindowStartDate?: InputMaybe<DateDateFilterLookup>;
    hasAddress?: InputMaybe<BoolBaseFilterLookup>;
    hasEpisode?: InputMaybe<BoolBaseFilterLookup>;
    hasOrder?: InputMaybe<BoolBaseFilterLookup>;
    hasServiceArea?: InputMaybe<BoolBaseFilterLookup>;
    hasServices?: InputMaybe<BoolBaseFilterLookup>;
    hasVisit?: InputMaybe<BoolBaseFilterLookup>;
    id?: InputMaybe<UuidBaseFilterLookup>;
    inDateWindow?: InputMaybe<DateWindowInput>;
    metadata?: InputMaybe<JsonjsonFilterLookup>;
    needsAttention?: InputMaybe<BoolBaseFilterLookup>;
    needsClinicians?: InputMaybe<BoolBaseFilterLookup>;
    needsServices?: InputMaybe<BoolBaseFilterLookup>;
    numClinicianAppointments?: InputMaybe<IntComparisonFilterLookup>;
    patient?: InputMaybe<PatientFilter>;
    plannedInDateWindow?: InputMaybe<OptionalDateWindowInput>;
    plannedInWindow?: InputMaybe<OptionalTimeWindowInput>;
    priority?: InputMaybe<VisitPriorityBaseFilterLookup>;
    relatedOrder?: InputMaybe<OrderFilter>;
    serviceArea?: InputMaybe<ServiceAreaFilter>;
    services?: InputMaybe<ServiceFilter>;
    state?: InputMaybe<VisitRequestStateBaseFilterLookup>;
    syncStatus?: InputMaybe<SyncStatusFilter>;
    tentativeDate?: InputMaybe<DateDateFilterLookup>;
    territories?: InputMaybe<TerritoryFilter>;
    visit?: InputMaybe<VisitFilter>;
    workflowStep?: InputMaybe<VisitRequestWorkflowStepBaseFilterLookup>;
};

export type VisitRequestOrdering = {
    createdAt?: InputMaybe<Ordering>;
    effectiveDate?: InputMaybe<Ordering>;
    episode?: InputMaybe<EpisodeOfCareOrdering>;
    fulfillmentWindowEndDate?: InputMaybe<Ordering>;
    fulfillmentWindowStartDate?: InputMaybe<Ordering>;
    patient?: InputMaybe<PatientOrdering>;
    serviceArea?: InputMaybe<ServiceAreaOrdering>;
    tentativeDate?: InputMaybe<Ordering>;
    updatedAt?: InputMaybe<Ordering>;
};

export type VisitRequestPaginatedList = {
    __typename?: 'VisitRequestPaginatedList';
    hasMore: Scalars['Boolean']['output'];
    items: VisitRequest[];
    totalCount: Scalars['Int']['output'];
};

export type VisitRequestPermissions = {
    __typename?: 'VisitRequestPermissions';
    edit: Scalars['Boolean']['output'];
    id: Scalars['UUID']['output'];
    view: Scalars['Boolean']['output'];
};

export enum VisitRequestState {
    CANCELED = 'CANCELED',
    FULFILLED = 'FULFILLED',
    PENDING = 'PENDING',
}

export type VisitRequestStateBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<VisitRequestState>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<VisitRequestState[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VisitRequestWarning = {
    __typename?: 'VisitRequestWarning';
    message: Scalars['String']['output'];
    type: VisitRequestWarningType;
};

export enum VisitRequestWarningType {
    PLACEHOLDER_TYPE = 'PLACEHOLDER_TYPE',
}

export enum VisitRequestWorkflowStep {
    COMPLETED = 'COMPLETED',
    NEEDS_CLINICIAN = 'NEEDS_CLINICIAN',
    NEEDS_SERVICES = 'NEEDS_SERVICES',
    NEEDS_TENTATIVE_DATE = 'NEEDS_TENTATIVE_DATE',
    READY_FOR_PROMOTION = 'READY_FOR_PROMOTION',
    UNKNOWN = 'UNKNOWN',
}

export type VisitRequestWorkflowStepBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<VisitRequestWorkflowStep>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<VisitRequestWorkflowStep[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VisitReview = {
    __typename?: 'VisitReview';
    clinician: Clinician;
    comments: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTime']['output'];
    id: Scalars['ID']['output'];
    nps: Maybe<Scalars['Int']['output']>;
    rating: Scalars['Float']['output'];
    updatedAt: Scalars['DateTime']['output'];
    visit: Visit;
};

export enum VisitState {
    AT_LOCATION = 'AT_LOCATION',
    CONFIRMED = 'CONFIRMED',
    ENDED = 'ENDED',
    EN_ROUTE = 'EN_ROUTE',
    IN_REVIEW = 'IN_REVIEW',
    SCHEDULED = 'SCHEDULED',
    UNSCHEDULED = 'UNSCHEDULED',
}

export type VisitStateBaseFilterLookup = {
    /** Exact match. Filter will be skipped on `null` value */
    exact?: InputMaybe<VisitState>;
    /** Exact match of items in a given list. Filter will be skipped on `null` value */
    inList?: InputMaybe<VisitState[]>;
    /** Assignment test. Filter will be skipped on `null` value */
    isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VisitStateChange = {
    __typename?: 'VisitStateChange';
    createdAt: Scalars['DateTime']['output'];
    state: VisitState;
    updatedAt: Scalars['DateTime']['output'];
};

export type VisitTimeslotPreference = {
    __typename?: 'VisitTimeslotPreference';
    endDatetime: Scalars['DateTime']['output'];
    startDatetime: Scalars['DateTime']['output'];
};

export type VisitTimeslotPreferenceFilter = {
    AND?: InputMaybe<VisitTimeslotPreferenceFilter>;
    DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
    NOT?: InputMaybe<VisitTimeslotPreferenceFilter>;
    OR?: InputMaybe<VisitTimeslotPreferenceFilter>;
    endDatetime?: InputMaybe<DatetimeDatetimeFilterLookup>;
    startDatetime?: InputMaybe<DatetimeDatetimeFilterLookup>;
};

export type VisitTimeslotPreferenceInput = {
    endDatetime: Scalars['DateTime']['input'];
    startDatetime: Scalars['DateTime']['input'];
};

export type VisitVisitRequest = Visit | VisitRequest;

export type VisitWarning = {
    __typename?: 'VisitWarning';
    message: Scalars['String']['output'];
    type: VisitWarningType;
};

export enum VisitWarningType {
    PLACEHOLDER_TYPE = 'PLACEHOLDER_TYPE',
}

export type VisitishClinicianAppointmentClinicianRecommendation = {
    __typename?: 'VisitishClinicianAppointmentClinicianRecommendation';
    amortizedVisitCountInFulfillmentWindowScore: Scalars['Float']['output'];
    amortizedVisitDurationMinutesInFulfillmentWindowScore: Scalars['Float']['output'];
    clinician: Clinician;
    continuityOfCareScore: Scalars['Int']['output'];
    distanceFromFutureVisitsCentroidMi: Scalars['Float']['output'];
    hasCompatibleShift: Scalars['Boolean']['output'];
    /** @deprecated Use `amortized_visit_count_in_fulfillment_window_score` instead. */
    incompleteVisitCount: Scalars['Float']['output'];
    isClinicianCompatible: Scalars['Boolean']['output'];
    /** @deprecated Use `is_clinician_compatible` instead. This field only checks clinician eligibility, not shift compatibility. */
    isCompatible: Scalars['Boolean']['output'];
    /** @deprecated Use `would_clinician_be_overfull_by_amortized_visit_duration` instead. */
    isFullByMaxVisitCount: Scalars['Boolean']['output'];
    isInDefaultTerritory: Scalars['Boolean']['output'];
    isSatisfactory: Scalars['Boolean']['output'];
    licenseValue: Scalars['Int']['output'];
    llmNotesParsingReason: Scalars['String']['output'];
    llmNotesParsingScore: Scalars['Float']['output'];
    recommendationRank: Scalars['Int']['output'];
    satisfiesGenderPreference: Scalars['Boolean']['output'];
    satisfiesLanguagePreference: Scalars['Boolean']['output'];
    spareShiftHours: Scalars['Float']['output'];
    spareShiftHoursNormalizedScore: Scalars['Int']['output'];
    wouldClinicianBeOverfullByAmortizedMaxVisitsPerHour: Scalars['Boolean']['output'];
    wouldClinicianBeOverfullByAmortizedVisitDuration: Scalars['Boolean']['output'];
};

export type VisitishDateRecommendation = {
    __typename?: 'VisitishDateRecommendation';
    date: Scalars['Date']['output'];
    dayOfWeek: Scalars['String']['output'];
    distanceFromClinicianScheduleCentroidMi: Scalars['Float']['output'];
    distanceScore: Scalars['Float']['output'];
    doesRespectOneDaySpacingWithinOrder: Scalars['Boolean']['output'];
    doesRespectZeroDaySpacingWithinOrder: Scalars['Boolean']['output'];
    hasShifts: Scalars['Boolean']['output'];
    /** @deprecated Use `num_incomplete_visits_on_date_for_busiest_clinician` instead. */
    incompleteVisitCount: Scalars['Int']['output'];
    /** @deprecated Use `would_clinician_be_overfull_by_visit_duration` instead. */
    isFullByMaxVisitCount: Scalars['Boolean']['output'];
    isInFuture: Scalars['Int']['output'];
    isSatisfactory: Scalars['Boolean']['output'];
    llmNotesParsingReason: Scalars['String']['output'];
    llmNotesParsingScore: Scalars['Float']['output'];
    matchesExistingVisitAddress: Scalars['Boolean']['output'];
    numIncompleteVisitsOnDateForBusiestClinician: Scalars['Int']['output'];
    recommendationRank: Scalars['Int']['output'];
    wouldClinicianBeOverfullByMaxVisitsPerHour: Scalars['Boolean']['output'];
    wouldClinicianBeOverfullByVisitDuration: Scalars['Boolean']['output'];
};
